import get from 'lodash/get';
import { filterCommonKey } from '@pm/super-library-2';
import { getSeamlessPromotions, checkSeamlessMemberPromotionStatus, getSeamlessPromotionInfo, getSeamlessPromotionInfoByPathParam } from '@pm/super-library-2/modules/seamless';
import { getCookie } from '@pm/super-library-2/utils';

import memberService from 'root/util/member-service';
import core from 'root/util/core';
import { referralAction, luckyWheelAction, consolidateAPIAction, seamlessAction, myVipAction, gameAction, languageAction } from 'root/redux/action';
import userNotificationAlert from 'root/util/user-verification-alert';
import notification from 'root/util/notification';
import { featureConfigClient } from 'root/ms/ms-service';

import { MASTER_SWITCH_MODULE_TYPE } from '@utils/constants';
import { fetchAuthSettings } from '@redux/slice/auth-settings-slice';
import { OTP_VERIFICATION_METHOD, MODULE_TYPE, PROVIDER_CATEOGRY_PREFIX } from '@constants';
import { seamless_getWallet, seamless_fullSeamlessMode } from '@utils/seamless-util';

import { userAction } from '../redux/action/user.action';
import {
    portalIsLoading,
    gu_massageIndex,
    gu_getContentByCurrencyLanguage,
    gu_getNestedValue,
    gu_filterCommonKey,
    gu_togglePopup,
    gu_getDefaultUrl,
    gu_deepCopy,
    gu_getAffiliateLink,
    gu_isNumber,
    gu_isValidAlphanumeric,
    gu_getSettingFromPortalSettings,
    gu_formatCurrentLanguage,
    gu_updateComponentProps,
} from './general-util';

// NOTE: This file is same as commmon-util
// MAIN PURPOSE: enhancement project performance, without import all the unused function
// The way is to export function 1 by 1 for this file
// All function name start from mu (member util) to indicate the function come from here

export function mu_getVerificationDialog(vm, verify, continueSubmitCallback) {
    let birthdateVerify = false;
    let emailVerify = false;
    let bankVerify = false;
    let phoneVerify = false;
    let fullnameVerify = false;

    if (verify === 'birthdate' || verify === 'birthdayVerified') {
        birthdateVerify = true;
    } else if (verify === 'email' || verify === 'emailVerified') {
        emailVerify = true;
    } else if (verify === 'bank' || verify === 'withdrawalVerified') {
        bankVerify = true;
    } else if (verify === 'phone' || verify === 'phoneVerified') {
        phoneVerify = true;
    } else if (verify === 'fullname' || verify === 'nameVerified') {
        fullnameVerify = true;
    } else if (verify === 'forgetWithdrawalPin') {
        vm.setState({
            forgotWithdrawalPinDialogIsShow: true,
        });
    }

    vm.setState({
        emailVerificationDialogIsShow: emailVerify,
        bankVerificationDialogIsShow: bankVerify,
        phoneVerificationDialogIsShow: phoneVerify,
        phoneVerificationDialogClosedCallback: continueSubmitCallback,
        birthdateVerificationDialogIsShow: birthdateVerify,
        nameVerificationDialogIsShow: fullnameVerify,
    });
}

export function mu_getContactVerification(vm) {
    const { portal, location } = vm.props;

    if (gu_getNestedValue(vm.props, 'user.verifications.personal.emailVerified')) {
        vm.setState({
            pendingVerify: false,
        });
    }

    vm.setState({
        birthdateNotVerified: !gu_getNestedValue(vm.props, 'user.verifications.personal.birthdayVerified'),
        nameNotVerified: !gu_getNestedValue(vm.props, 'user.verifications.personal.nameVerified'),
    });

    const showUserVerificationAlert = gu_filterCommonKey(portal, 'settings.features.settingsConfiguration.memberVerificationSettings.pageShowVerificationAlert') || '';

    if (!gu_getNestedValue(vm.props, 'user.verifications.personal.nameVerified') && showUserVerificationAlert && showUserVerificationAlert.indexOf(location.pathname) > -1) {
        let targetPage = gu_filterCommonKey(vm.props.portal, 'settings.features.settingsConfiguration.memberVerificationSettings.redirectPage');

        userNotificationAlert.showNotification('error', 'global:global.verification.nameAlertMsg', {
            autoClose: false,
            closeOnClick: true,
            onClick: vm.props.history.push(targetPage),
        });
    }

    // const { portal, location } = vm.props;

    // window.SPL_Member.loadContactsVerification().then((res) => {
    //     if (res) {
    //         let { pendingVerify, supportedVerificationOptions } = vm.state;
    //         let userVerificationStep = 0;
    //         let userFullyVerified = false;

    //         if (res.emailVerified) {
    //             pendingVerify = false;
    //         }

    //         // process verification bar
    //         // some merchant may dont have some verification, step+ only when supported verification and the value from api is matched
    //         for (let key in res) {
    //             if (res[key] && supportedVerificationOptions && supportedVerificationOptions[key]) {
    //                 userVerificationStep++;
    //             }
    //         }
    //         if (supportedVerificationOptions) {
    //             userFullyVerified = userVerificationStep === Object.keys(supportedVerificationOptions).length ? true : false;
    //         }

    //         commonUtil.updateUserVerifications(vm, { ...res, userVerificationStep });

    //         vm.setState(
    //             {
    //                 pendingVerify: pendingVerify,
    //                 userFullyVerified: userFullyVerified,
    //                 birthdateNotVerified: !res.birthdayVerified,
    //                 nameNotVerified: !res.nameVerified,
    //             },
    //             () => {
    //                 const showUserVerificationAlert =
    //                     gu_filterCommonKey(portal, 'settings.features.settingsConfiguration.memberVerificationSettings.pageShowVerificationAlert') || '';
    //                 if (vm.state.nameNotVerified && showUserVerificationAlert && showUserVerificationAlert.indexOf(location.pathname) > -1) {
    //                     let targetPage = gu_filterCommonKey(
    //                         vm.props.portal, 'settings.features.settingsConfiguration.memberVerificationSettings.redirectPage'
    //                     );

    //                     userNotificationAlert.showNotification('error', 'global:global.verification.nameAlertMsg', {
    //                         autoClose: false,
    //                         closeOnClick: true,
    //                         onClick: vm.props.history.push(targetPage),
    //                     });
    //                 }
    //             }
    //         );
    //     }
    // });
}

export function mu_getContactVerificationStatus(vm) {
    const { user } = vm.props;
    let param = {
        email: user.account.email,
    };
    if (!vm.props?.authSettingsReducer?.enableNewOTP) {
        window.SPL_Member.getContactVerificationStatus(param).then((status) => {
            if (status && status !== 'error') {
                vm.setState({ checkEmailStatus: 'ENTER_OTP', pendingVerify: true });
            } else {
                vm.setState({ checkEmailStatus: '' });
            }
        });
    }
}

export function mu_getUserSeamlessStatus(vm) {
    const { features } = vm.props.portal.settings;
    const { isLogin, account } = vm.props.user;
    const { currencyLang } = vm.props.language;
    const hideFlag = (gu_filterCommonKey(features?.hideInCurrencyList) || []).includes(currencyLang);

    if (features && features.homeWalletSeamless) {
        vm.setState({ homeWalletSeamless: hideFlag ? false : features.homeWalletSeamless }, () => {
            if (vm.state.updateState) {
                gu_updateComponentProps(vm, 'mobileWalletProps', {
                    homeWalletSeamless: hideFlag ? false : features.homeWalletSeamless,
                });
            }
        });
    }

    if (isLogin === true) {
        window.SPL_Member.loadMemberSeamlessStatus({
            memberId: account?.id,
        }).then((res) => {
            vm.setState({ hasFakeSeamLess: res.hasFakeSeamless, disabledSeamless: res.isFakeSeamlessDisabled }, () => {
                if (vm.state.updateState) {
                    gu_updateComponentProps(vm, 'mobileWalletProps', {
                        hasFakeSeamLess: res.hasFakeSeamless,
                        disabledSeamless: res.isFakeSeamlessDisabled,
                    });
                }
            });
        });
    }
}

export async function mu_getSettingMenu(vm) {
    const { user, location, portal, authSettingsReducer, seamless } = vm.props;

    let defaultAccountMenu = [
        { id: 'transfer', path: '/myaccount/transfer', svgIcon: 'transferall', text: 'settings:settings.tabs.heading.transfer' },
        { id: 'deposit', path: '/myaccount/deposit', svgIcon: 'deposit', text: 'settings:settings.tabs.heading.deposit' },
        { id: 'withdraw', path: '/myaccount/withdraw', svgIcon: 'withdraw', text: 'settings:settings.tabs.heading.withdraw' },
        { id: 'history', path: '/myaccount/history', svgIcon: 'history', text: 'settings:settings.tabs.heading.history' },
    ];
    let defaultProfileMenu = [
        { id: 'profile', path: '/myaccount/profile', svgIcon: 'iconprofile', text: 'settings:settings.profiletab.myprofile' },
        { id: 'changePassword', path: '/myaccount/changepassword', svgIcon: 'changepw', text: 'settings:settings.profiletab.changepass' },
        { id: 'changeGamePassword', path: '/myaccount/changegamepassword', svgIcon: 'changepw', text: 'settings:settings.profiletab.changeproviderpass' },
        { id: 'messaging', path: '/myaccount/messaging', svgIcon: 'messaging', text: 'settings:settings.tabs.heading.message' },
        { id: 'bankDetails', path: '/myaccount/bankdetails', svgIcon: 'bankdetail', text: 'settings:settings.profiletab.bank' },
        { id: 'referral', path: '/myaccount/referral', svgIcon: 'myreferral', text: 'settings:settings.profiletab.referral' },
    ];

    let pathname = location.pathname;
    let accountMenu = defaultAccountMenu;
    let profileMenu = defaultProfileMenu;
    let accountPageSettings = gu_getSettingFromPortalSettings({
        vm: vm,
        settingName: 'accountPageSettings',
    });

    if (accountPageSettings.customAccountMenu) {
        accountMenu = accountPageSettings.customAccountMenu;
    }
    if (accountPageSettings.customProfileMenu) {
        profileMenu = filterCommonKey(accountPageSettings.customProfileMenu);
    }
    if (mu_isSixDigitPinUnderProfile(vm.props?.portal?.settings?.features?.accountPageSettings)) {
        profileMenu = profileMenu.filter((menu) => menu?.id !== 'sixDigitPin');
    }

    let enableReferralMenu = profileMenu.some(function (el) {
        return el.id === 'referral';
    });

    //affiliate need to hide it when need to use the menu dropdown
    if (enableReferralMenu && !window.isAffiliate) {
        await validateReferralTab(profileMenu);
    }
    await callback();

    async function callback() {
        const isFullSeamless = portal.settings?.features?.isFullSeamless && seamless?.isSeamless;

        profileMenu = await mu_getSixDigitPin(
            profileMenu,
            authSettingsReducer?.processedData?.[MODULE_TYPE.SIX_PIN]?.[MODULE_TYPE.SIX_PIN]?.enabled,
            authSettingsReducer?.processedData?.[MODULE_TYPE.SIX_PIN]?.[MODULE_TYPE.SIX_PIN]?.uiType
        );

        for (let i = 0; i < accountMenu.length; i++) {
            // multiHLpart used for highlight multi page if they are under 1 category
            if (
                (pathname.split('/')[2] &&
                    accountMenu[i].path &&
                    accountMenu[i].path.split('/')[2] &&
                    pathname.split('/')[2].indexOf(accountMenu[i].path.split('/')[2]) !== -1) ||
                (accountMenu[i].multiHLPart && accountMenu[i].multiHLPart.indexOf(pathname) !== -1)
            ) {
                accountMenu[i].selected = true;
            } else {
                accountMenu[i].selected = false;
            }

            if (user && user.account && user.account.currency) {
                if (accountMenu[i].hideInCurrency && accountMenu[i].hideInCurrency.includes(user.account.currency)) {
                    accountMenu.splice(i, 1);
                }
            }
        }

        for (let i = 0; i < profileMenu.length; i++) {
            // multiHLpart used for highlight multi page if they are under 1 category
            if (pathname.indexOf(profileMenu[i].path) !== -1 || (profileMenu[i].multiHLPart && profileMenu[i].multiHLPart.indexOf(pathname) !== -1)) {
                profileMenu[i].selected = true;
            } else {
                let splitPathname = pathname.split('/').filter((a) => a !== 'myaccount' && a !== '');
                let splitProfilemenuPath = profileMenu[i].path.split('/').filter((a) => a !== 'myaccount' && a !== '');
                let foundList = splitPathname.filter(function (n) {
                    return splitProfilemenuPath.indexOf(n) !== -1;
                });

                if (foundList.length > 0) {
                    profileMenu[i].selected = true;
                } else {
                    profileMenu[i].selected = false;
                }
            }

            if (user && user.account && user.account.currency) {
                if (profileMenu[i].hideInCurrency && (profileMenu[i].hideInCurrency.includes(user.account.currency) || profileMenu[i].hideInCurrency.includes('ALL'))) {
                    profileMenu.splice(i, 1);
                }
            }
        }

        if (accountPageSettings.customAccountMenu) {
            accountMenu.sort(function (a, b) {
                return accountPageSettings.customAccountMenu.indexOf(a) - accountMenu.indexOf(b);
            });
        }

        if (accountPageSettings.customProfileMenu) {
            profileMenu.sort(function (a, b) {
                return filterCommonKey(accountPageSettings.customProfileMenu).indexOf(a) - profileMenu.indexOf(b);
            });
        }

        const updatedAccountMenu = isFullSeamless ? seamless_fullSeamlessMode(accountMenu) : accountMenu;

        vm.setState({ accountMenu: updatedAccountMenu, profileMenu });
    }

    function validateReferralTab(menu) {
        function _callback(resolve, referralRewards, referralComm, isMultiTierReferral) {
            if (!referralRewards && !referralComm && !isMultiTierReferral) {
                let index = menu.findIndex((i) => i.id === 'referral');
                menu.splice(index, 1);
            }
            resolve();
        }

        return new Promise((resolve) => {
            mu_getReferralTypeEnabled(vm, _callback).then(() => {
                resolve();
            });
        });
    }
}

const SIX_DIGIT_PIN_PROFILE_PATH = '/myaccount/profile?sixDigitPin';
const SIX_DIGIT_PIN_STANDALONE_PATH = '/myaccount/six-digit-pin';

export function mu_getSixDigitPin(profileMenu, isSixDigitPinEnabled, sixDigitPinUI, translation = null) {
    const isPopupUI = typeof sixDigitPinUI === 'string' && sixDigitPinUI.toLowerCase() === 'popup';

    if (!isPopupUI && isSixDigitPinEnabled && profileMenu.map((menu) => menu.id).indexOf('sixDigitPin') === -1) {
        const sixDigitPinObj = [
            {
                id: 'sixDigitPin',
                path: SIX_DIGIT_PIN_STANDALONE_PATH,
                svgIcon: 'six-digit-pin',
                text: translation || '6 Digit Pin',
                key: 'sixDigitPin',
                locale: translation || '6 Digit Pin',
                imgPath: '/public/html/default_whitelabel/shared-image/icons/6D_PIN_Icon.png',
                isNavigation: true,
                notificationItem: null,
            },
        ];
        profileMenu = [...profileMenu, ...sixDigitPinObj];
    } else if (profileMenu.map((menu) => menu.id).indexOf('sixDigitPin') > -1 && !isSixDigitPinEnabled) {
        profileMenu = profileMenu.filter((tab) => tab.id !== 'sixDigitPin');
    }

    return profileMenu;
}

export function mu_isSixDigitPinUnderProfile(accountPageSettings = {}) {
    if (window.isAffiliate) return false;

    return gu_filterCommonKey(accountPageSettings?.moveSixDigitPinToProfileTab) === true;
}

export function mu_getSixDigitPinPath(accountPageSettings = {}) {
    return mu_isSixDigitPinUnderProfile(accountPageSettings) ? SIX_DIGIT_PIN_PROFILE_PATH : SIX_DIGIT_PIN_STANDALONE_PATH;
}

export function mu_getReferralTypeEnabled(vm, _callback) {
    return new Promise((resolve) => {
        const { referralProps } = vm.props;

        if (referralProps && referralProps.isUpdated) {
            const { enableReferralProgram, enableReferralCommProgram, isMultiTierReferral, disableMemberBecomeReferral } = referralProps;
            _callback(resolve, enableReferralProgram, enableReferralCommProgram, isMultiTierReferral, disableMemberBecomeReferral);
        } else {
            let getReferralType = new Promise(function (resolve) {
                vm.props
                    .dispatch(consolidateAPIAction.getReferralTypeEnabledAndMemberSummaryGroupAutomation(vm))
                    .then((data) => {
                        let referralRewards = gu_getNestedValue(data, 'referralTypeResonseDTO.referralRewards');
                        let referralComm = gu_getNestedValue(data, 'referralTypeResonseDTO.referralComm');
                        let disableMemberBecomeReferral = gu_getNestedValue(data, 'disableMemberBecomeReferral');
                        resolve({ referralRewards, referralComm, disableMemberBecomeReferral });
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });

            getReferralType.then((result) => {
                if (!result) {
                    _callback(resolve, false, false, false, false);
                    return;
                }

                const referralRewards = typeof result.referralRewards === 'boolean' ? result.referralRewards : result;

                const referralComm = typeof result.referralComm === 'boolean' ? result.referralComm : result;

                const disableMemberBecomeReferral = result.disableMemberBecomeReferral;

                _callback(resolve, referralRewards, referralComm, referralProps?.isMultiTierReferral, disableMemberBecomeReferral);
            });
        }
    });
}

// used in menu-slice redux
export async function mu_getReferralTypeEnabledV2(vm) {
    const { referralProps } = vm.props;

    if (referralProps && referralProps.isUpdated) {
        const { enableReferralProgram, enableReferralCommProgram, isMultiTierReferral } = referralProps;
        return { enableReferralProgram, enableReferralCommProgram, isMultiTierReferral };
    } else {
        try {
            const referralTypeData = await vm.props.dispatch(consolidateAPIAction.getReferralTypeEnabledAndMemberSummaryGroupAutomation(vm));

            const referralRewards = referralTypeData?.referralTypeResonseDTO?.referralRewards;
            const referralComm = referralTypeData?.referralTypeResonseDTO?.referralComm;

            const isMultiTierReferral = referralProps?.isMultiTierReferral;

            return { referralRewards, referralComm, isMultiTierReferral };
        } catch (error) {
            return false;
        }
    }
}

export function mu_initSP2ReferralSetting(vm, enableReferralProgram, enableReferralCommProgram, _callback, isMultiTierReferral, disableMemberBecomeReferral) {
    const { user, language, portal, history, flagsmith } = vm.props;
    let { currency } = user.account || {};
    let { key: lang, currencyLang } = language;
    let countryLanguageKey = language.countryLanguageKey.toLowerCase().replace('_', '-');
    let { settings: portalSettings } = portal;

    // TODO: will remove isPreventCallApiReferralDetails flagsmith when production is stable
    const { isPreventCallApiReferralDetails } = flagsmith?.depositCashmarketApi || {};
    const disabledCallApiReferralDetails = !history?.location?.pathname?.includes('referral') && isPreventCallApiReferralDetails;

    window.SPL_Referral.initSP2ReferralSetting(
        currency,
        lang,
        window.globMerchantName,
        countryLanguageKey,
        portalSettings,
        vm.props.language.country,
        enableReferralProgram,
        enableReferralCommProgram,
        isMultiTierReferral,
        disableMemberBecomeReferral,
        disabledCallApiReferralDetails
    ).then((data) => {
        let hideShareContent = gu_getNestedValue(portal, 'settings.referralOption.hideShareContent');
        if (hideShareContent) {
            data.referralSetting.hideShareContent = hideShareContent;
        }

        if (data && data.referralSetting && data.referralSetting.socialMediaReferral) {
            if (Object.keys(data.referralSetting.socialMediaReferral).includes(currencyLang)) {
                data.referralSetting.socialMediaReferral = data.referralSetting.socialMediaReferral[currencyLang];
            }
        }

        data.referralSetting.hideRefereeBonus = gu_getNestedValue(portal, 'settings.features.referralSettings.hideRefereeBonus');
        vm.props.dispatch(referralAction.getAllReferralSettings(data));

        if (_callback) {
            _callback(data);
        }
    });
}

export function mu_getMessagesTab(vm) {
    portalIsLoading(vm.props, true);

    const portal = vm.props.portal;
    const enableRewardPoint = gu_filterCommonKey(portal?.settings?.features?.enableRewardPoint) || false;

    memberService.getMemberMessageCount(vm.props).then((count) => {
        let defaultMessageDisplayTab = [
            {
                id: 'all',
                tabHeader: 'message:message.allTab',
                selected: false,
                isNotification: true,
                pathname: '/myaccount/messaging',
                unreadMsg: 'unreadMsg',
                messageType: null,
            },
            {
                id: 'promotions',
                tabHeader: 'message:message.promoTab',
                selected: false,
                isNotification: false,
                pathname: '/myaccount/messaging',
                unreadMsg: 'unreadPromotionCount',
                messageType: 'P',
            },
            {
                id: 'payment',
                tabHeader: 'message:message.paymentTab',
                selected: false,
                isNotification: false,
                pathname: '/myaccount/messaging',
                unreadMsg: 'unreadPaymentCount',
                messageType: 'PT',
            },
            {
                id: 'system',
                tabHeader: 'message:message.systemTab',
                selected: false,
                isNotification: true,
                pathname: '/myaccount/messaging',
                unreadMsg: 'unreadInboxCount',
                messageType: 'N',
            },
            {
                id: 'notification',
                tabHeader: 'message:message.notificationTab',
                selected: false,
                isNotification: true,
                pathname: '/myaccount/messaging',
                unreadMsg: 'unreadNotificationsCount',
                messageType: 'I',
            },
            {
                id: 'rewards',
                tabHeader: 'message:message.externalRewards',
                selected: false,
                isNotification: true,
                pathname: '/myaccount/messaging',
                unreadMsg: 'unreadExternalRewardCount',
                messageType: 'ER',
            },
        ];

        if (!enableRewardPoint) {
            defaultMessageDisplayTab = defaultMessageDisplayTab.filter((tab) => tab.id !== 'rewards');
        }

        let displayTab = defaultMessageDisplayTab;
        let compSettings = gu_getSettingFromPortalSettings({
            vm,
            settingName: 'messagingConfiguration',
            notViewType: true,
            notFeatures: true,
        });

        if (compSettings && compSettings.displayTabInfo) {
            let displayTabInfo = compSettings.displayTabInfo;

            if (!enableRewardPoint) {
                displayTabInfo = displayTabInfo.filter((tab) => tab.id !== 'rewards');
            }

            for (let i = 0; i < displayTabInfo.length; i++) {
                const currentDisplayTabInfo = displayTabInfo[i];

                currentDisplayTabInfo.unreadMsgCount = count[currentDisplayTabInfo.unreadMsg];
            }

            displayTab = displayTabInfo;
        }

        vm.setState({ displayTab }, () => {
            mu_getSelectedMessagesTab(vm);
        });
    });
}

export function mu_getSelectedMessagesTab(vm) {
    const { history } = vm.props;
    const { displayTab } = vm.state;
    const { messagingConfiguration } = vm.props.portal.settings;
    let selectedInboxType = '';
    let selectedMessageType = '';
    let isNotification = false;
    // filter pathname
    let pathname = history.location.pathname.split('/');
    let index = pathname.findIndex((i) => i === 'detail');

    if (index > 0) pathname.splice(index, pathname.length);
    let filteredPathname = pathname.join('/');

    // first condition - use for beta, beta has different pathnames with different categories
    // second condition - use for all mc including ss2,96b
    for (let i = 0; i < displayTab.length; i++) {
        if (displayTab[i].pathname === filteredPathname && messagingConfiguration && messagingConfiguration.enableMsgTypeWithSpecificPath) {
            displayTab[i].selected = true;
            if (displayTab[i].messageType) {
                selectedMessageType = displayTab[i].messageType;
            } else {
                selectedInboxType = displayTab[i].inboxType;
                isNotification = displayTab[i].isNotification;
            }
        } else if (displayTab[i].pathname !== filteredPathname) {
            displayTab[i].selected = false;
        } else {
            displayTab[0].selected = true;
            if (history && history.location && history.location.state && history.location.state.msgType) {
                selectedMessageType = history.location.state.msgType;
            } else if (vm.props.user.messageType) {
                selectedMessageType = vm.props.user.messageType;
            } else {
                selectedMessageType = displayTab[0].messageType;
            }
        }

        // else {
        //     displayTab[i].selected = false;
        // }
    }
    vm.setState({ displayTab, currentInboxType: selectedInboxType, currentMessageType: selectedMessageType, isNotification, currentPage: 1 }, () => {
        portalIsLoading(vm.props, false);
        mu_getMemberMessages(vm);
    });
}

export function mu_freeSpinGenerateLink(vm, providerCode) {
    const { menuSlice, language } = vm?.props || {};
    const isMenuV3 = window.isMenuV3 && menuSlice.menuList;
    const { floatingFreeSpinSettings, hideLangPathUrl } = vm?.props?.portal?.settings?.features || {};
    const { ctaLink, menuCode, useLandingPage = false } = floatingFreeSpinSettings || {};

    const subCategory = menuCode || 'SL';
    const providers = isMenuV3 ? menuSlice.processedBaseMenuSettings.subCategoryMenus?.[subCategory] : menuSlice?.baseMenuSettings?.web?.subCategory?.[subCategory]?.submenu;
    const providerMatched = providers?.find((item) => item.provider === providerCode);

    const langPath = gu_formatCurrentLanguage(language?.countryLanguageKey);
    const currentLang = hideLangPathUrl === true || hideLangPathUrl?.[langPath] ? '' : `/${langPath}`;

    return ctaLink ? `${currentLang}${ctaLink}` : `${currentLang}${(useLandingPage ? providerMatched?.landingRoute : providerMatched?.route) ?? `/slots/${providerCode}`}`;
}

export function mu_applyExternalRewardLink(message, externalRewardLink) {
    if (!message.includes("id='external_reward_url'")) {
        return message; // No modification needed if the link is not found
    }

    message = message.replace(
        /<a\s+id="external_reward_url"(.*?)href="javascript:void\(0\);"(.*?)>/g,
        `<a id="external_reward_url"$1 href="${externalRewardLink}" target="_blank"$2>`
    );

    // Update the DOM element if needed
    const link = document.getElementById('external_reward_url');
    if (link) {
        link.setAttribute('href', externalRewardLink);
        link.setAttribute('target', '_blank');
    }

    return message;
}

export function mu_formatMessage(vm, message) {
    // this one format link and datetime time for massage Free Spin, message type "I"
    // Replace {{text translation <<providerCode>>}} with a linked format
    let formattedMessage = message?.replaceAll(/{{(.*?)\s*(?:<<|&lt;&lt;)\s*(.*?)\s*(?:>>|&gt;&gt;)}}/g, (_, textTranslation, providerCode) => {
        return `<a style="color:#3498db" href="${mu_freeSpinGenerateLink(vm, providerCode)}">${textTranslation}</a>`;
    });

    // Replace date format like 2024-11-23 16:59:59.000 to YYYY-MM-DD HH:MM
    formattedMessage = formattedMessage?.replaceAll(/\b(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):\d{2}\.\d{3}\b/g, (_, year, month, day, hour, minute) => {
        return `${year}-${month}-${day} ${hour}:${minute}`;
    });
    return formattedMessage;
}

export function mu_getMemberMessages(vm) {
    const { currentInboxType, currentMessageType, currentPage, isNotification, startEndFields, itemPerPage } = vm.state;
    const { portal, location } = vm.props;

    let pageNum = currentPage - 1;
    let _itemPerPage = itemPerPage ?? 5;
    let currentDate = new Date();
    let endDate = currentDate;
    let startEndParams = {
        start:
            startEndFields && startEndFields.start && portal && portal.settings && portal.settings.features && portal.settings.features.enableMessageStartEndDate
                ? new Date(new Date(startEndFields.start).setHours(0, 0, 0))
                : null,
        end: new Date(new Date(startEndFields && startEndFields.end ? startEndFields.end : endDate).setHours(23, 59, 59)),
    };

    // for filter message detail
    let state = vm.props.location.state;

    if (state && state.currentPage) {
        pageNum = state.currentPage - 1;
    }

    vm.setState({ isLoading: true });
    let getCurrentMessageType = currentMessageType || location?.state?.msgType;
    window.SPL_Member.getMessages(isNotification, pageNum, _itemPerPage, startEndParams, currentInboxType, getCurrentMessageType).then((data) => {
        let totalCount = data.headers['x-total-count'];
        let totalPage = Math.ceil(totalCount / _itemPerPage);
        // NOTE: message data sort by newest created at 1st index (pin feature consideration)
        let messageList = data.messages;
        let pinnedMessage = [];

        // for filter message detail
        let filteredMessageList = [];

        if (state && state.currentMsgId) {
            filteredMessageList = messageList.filter((e) => e.id === state.currentMsgId);
            mu_deductUnreadMsgCount(vm, filteredMessageList);
        }

        for (let i = messageList.length - 1, l = 0; i >= l; i--) {
            const currentMessage = messageList[i];
            currentMessage.isChecked = false;
            currentMessage.originalIndex = messageList.length - 1 - i;

            // NOTE: STATUS: N = NEW / R = READ / F = FLAG / FR = FLAG READ / FN = FlAG UNREAD
            if (currentMessage.status.indexOf('F') !== -1) {
                currentMessage.isFlagChecked = true;
            } else {
                currentMessage.isFlagChecked = false;
            }

            if (currentMessage.pin) {
                messageList.splice(i, 1);
                pinnedMessage.unshift(currentMessage);
            }

            if (isNotification) {
                messageList[i].message = mu_formatMessage(vm, messageList[i].message);
            }
        }

        messageList.unshift(...pinnedMessage);
        vm.setState(
            {
                messageList: messageList,
                currentPage: pageNum ? pageNum + 1 : 1,
                totalCount: totalCount,
                totalPage: totalPage,
                itemPerPage: _itemPerPage,
                filteredMessageList,
            },
            () => {
                mu_handlePagination(vm);
            }
        );
    });
}

export function mu_deductUnreadMsgCount(vm, messageObjList) {
    messageObjList.forEach((msg) => {
        if (msg.messageType === 'I') {
            msg.message = mu_formatMessage(vm, msg.message);
        }
        if (msg.status === 'N') {
            msg.status = msg.status.replace('N', 'R');

            let updateMessage = {
                id: msg.id,
                status: msg.status,
            };

            const { unreadMsg, unreadNotificationsCount, unreadPaymentCount, unreadPromotionCount, unreadInboxCount } = vm.props.user;

            if (unreadMsg && unreadMsg > 0) {
                switch (msg.messageType) {
                    case 'P':
                        vm.props.dispatch(userAction.getUnreadMsg(unreadMsg - 1, unreadNotificationsCount, unreadPaymentCount, unreadPromotionCount - 1, unreadInboxCount));
                        break;
                    case 'PT':
                        vm.props.dispatch(userAction.getUnreadMsg(unreadMsg - 1, unreadNotificationsCount, unreadPaymentCount - 1, unreadPromotionCount, unreadInboxCount));
                        break;
                    case 'N':
                        vm.props.dispatch(userAction.getUnreadMsg(unreadMsg - 1, unreadNotificationsCount, unreadPaymentCount, unreadPromotionCount, unreadInboxCount - 1));
                        break;
                    case 'I':
                        vm.props.dispatch(userAction.getUnreadMsg(unreadMsg - 1, unreadNotificationsCount - 1, unreadPaymentCount, unreadPromotionCount, unreadInboxCount));
                        break;
                    default:
                        break;
                }
            } else {
                vm.props.dispatch(userAction.getUnreadMsg(unreadMsg - 1));
            }

            window.SPL_Member.memberMessageUpdate(updateMessage);
        }
    });
}

export function mu_handlePagination(vm) {
    const { currentPage, totalPage } = vm.state;
    let pagingList = [];

    for (let i = 0; i < totalPage; i++) {
        let active = false;

        if (i + 1 === currentPage) {
            active = true;
        }

        let pageObj = {
            pageNum: i + 1,
            active: active,
        };

        pagingList.push(pageObj);
    }

    vm.setState({ pagingList: pagingList, isLoading: false });
}

export function mu_getProgressBarData(vm) {
    const { settings } = vm.props.portal;
    const { user, depositProgressBar, myVip } = vm.props;

    if (settings?.features?.showDepositTurnoverUpgradeInProfile) {
        let upgradeIndex = myVip?.member?.SettingInfo?.findIndex?.((item) => item.type === 'UPGRADE_CONDITION');
        upgradeIndex = Math.max(upgradeIndex, 0); // Ensure index is not negative
        const depositProgress = {
            maintainTotalDeposit: null,
            maintainTotalTurnover: null,
            memberCurrentGroupAutomationId: null,
            reviewDate: null,
            totalDeposit: myVip?.member?.SettingInfo?.[upgradeIndex]?.deposit?.currentPoint ?? null,
            totalDepositCount: null,
            totalValidTurnover: myVip?.member?.SettingInfo?.[upgradeIndex]?.validBet?.currentPoint ?? null,
            upgradeGroupName: null,
            upgradeTotalDeposit: myVip?.member?.SettingInfo?.[upgradeIndex]?.deposit?.totalPoint ?? null,
            upgradeTotalTurnover: myVip?.member?.SettingInfo?.[upgradeIndex]?.validBet?.totalPoint ?? null,
            statusProgress: myVip?.member?.SettingInfo?.[upgradeIndex]?.deposit?.totalPoint
                ? ((myVip?.member?.SettingInfo?.[upgradeIndex]?.deposit?.currentPoint || 0) / myVip?.member?.SettingInfo?.[upgradeIndex]?.deposit?.totalPoint) * 100
                : 0,
            statusProgressTurnover: myVip?.member?.SettingInfo?.[upgradeIndex]?.validBet?.upgradeTotalTurnover
                ? (myVip?.member?.SettingInfo?.[upgradeIndex]?.validBet?.totalPoint || 0) / myVip?.member?.SettingInfo?.[upgradeIndex]?.validBet?.upgradeTotalTurnover
                : 0,
            rules: myVip?.member?.SettingInfo?.[upgradeIndex]?.rules,
            memberLevel: myVip?.member?.info?.memberLevel,
            memberNextVipName: myVip?.member?.info?.memberNextVipName,
        };
        return vm.setState({
            iconLoading: false,
            depositProgress,
        });
    }

    if (settings && settings.features && settings.features.showDepositProgressNormal) {
        let showDepositProgressNormal = gu_getContentByCurrencyLanguage(vm, settings.features.showDepositProgressNormal);
        if (showDepositProgressNormal) {
            vm.setState(
                {
                    showDepositProgressBar: showDepositProgressNormal,
                    iconLoading: true,
                },
                () => {
                    if (user && user.account) {
                        if (depositProgressBar.isUpdated) {
                            vm.setState({
                                iconLoading: false,
                                depositProgress: depositProgressBar && depositProgressBar.details ? depositProgressBar.details : false,
                            });
                        } else {
                            vm.props
                                .dispatch(consolidateAPIAction.getReferralTypeEnabledAndMemberSummaryGroupAutomation(vm))
                                .then((data) => {
                                    if (data && data.memberGroupAutomationSummaryDTO) {
                                        const { memberGroupAutomationSummaryDTO } = data;
                                        vm.setState({
                                            iconLoading: false,
                                            depositProgress: memberGroupAutomationSummaryDTO,
                                        });
                                    } else {
                                        vm.setState({
                                            iconLoading: false,
                                        });
                                    }
                                })
                                .catch(() => {
                                    vm.setState({
                                        iconLoading: false,
                                    });
                                });
                        }
                    }
                }
            );
        }
    }
}

export function mu_onMessageFlagClicked(vm, messageObj) {
    const { messageList } = vm.state;

    messageObj.isFlagChecked = !messageObj.isFlagChecked;
    messageObj.isFlag = messageObj.isFlagChecked;
    window.SPL_Member.memberMessageUpdate(messageObj, () => {
        vm.setState({ messageList });
    });
}

export function mu_getLuckyWheelSpinSettingDetail(vm, cached = true) {
    return new Promise((resolve) => {
        const { language, user, luckyWheel } = vm.props;
        let currencyLang = language.currencyLang;

        if (language.country === 'KH' && currencyLang !== 'KHUSD') {
            currencyLang = 'KHUSD';
        }

        // Case 1: Data is already cached. Return an already resolved promise.
        if (cached && luckyWheel?.isUpdated && vm.state?.enableLuckyWheelPopup) {
            resolve(luckyWheel.details);
        }

        // Case 2: User is not logged in. Return the promise chain from the API call.
        if (!user.isLogin) {
            window.SPL_Member.getLuckyWheelSpinSettingDetailV2(window.merchantCode, currencyLang)
                .then((res) => {
                    vm.props.dispatch(luckyWheelAction.getLuckyWheelDetails(res || false));
                    resolve(res); // Resolve the main promise with the API response
                })
                .catch((error) => {
                    console.error('Failed to get lucky wheel details for guest:', error);
                    resolve(false); // Resolve with false on error
                });
        } else {
            // Case 3: User is logged in. Return the promise chain from the dispatch.
            vm.props
                .dispatch(consolidateAPIAction.getDailyMissionEnabledAndLuckyWheelDetails(cached))
                .then((data) => {
                    resolve(data ? data.luckyWheelDetail : false);
                })
                .catch((error) => {
                    console.error('Failed to get lucky wheel details for member:', error);
                    resolve(false); // Resolve with false on error
                });
        }
    });
}

export function mu_getMemberCryptoAddressAuth(vm) {
    const { props } = vm;
    if (props?.authSettingsReducer?.enableNewOTP) {
        getAuthSettingsFunction(MODULE_TYPE.CRYPTO_ADDRESS, vm);
    } else {
        window.SPL_Member.getMemberCryptoAddressAuth()
            .then((cryptoAddressAuth) => {
                vm.setState({ cryptoAddressAuth: cryptoAddressAuth });
                core.portalIsLoading(props, false);
            })
            .catch(() => {
                core.portalIsLoading(props, false);
            });
    }
}

export function mu_renderMemberNextLevelGroupImg(currentLevel) {
    let nextLevel = '';

    switch (currentLevel.toLowerCase()) {
        case 'regular':
            nextLevel = 'bronze';
            break;

        case 'bronze':
            nextLevel = 'silver';
            break;

        case 'silver':
            nextLevel = 'gold';
            break;

        case 'gold':
            nextLevel = 'platinum';
            break;

        case 'platinum':
            nextLevel = 'diamond';
            break;

        case 'normal':
            nextLevel = 'silver';
            break;

        default:
            nextLevel = currentLevel;
            break;
    }

    return nextLevel;
}

export async function mu_checkToShowMissionDiary(vm) {
    let newVm = {
        missionDiaryRedux: vm.props.missionDiary,
        dispatch: vm.props.dispatch,
    };

    if (window.isAffiliate) {
        return false;
    }

    const isDailyMissionEnabled = await mu_checkToShowMissionDiaryV2(newVm.missionDiaryRedux, newVm.dispatch);

    return isDailyMissionEnabled;
}

// using redux thunk
export async function mu_checkToShowMissionDiaryV2(missionDiaryRedux, dispatch) {
    const isCacheMissionDiaryEnabled = missionDiaryRedux?.isMissionDiaryEnabled;

    if (window.isAffiliate) {
        return;
    }

    if (isCacheMissionDiaryEnabled) {
        return true;
    } else {
        const data = await dispatch(consolidateAPIAction.getDailyMissionEnabledAndLuckyWheelDetails());
        return data?.isDailyMissionEnabled;
    }
}

export function mu_getBankMaintenanceStatus(bank) {
    return new Promise(function (resolve) {
        if (window.isAffiliate) {
            resolve(bank);
        } else {
            window.SPL_Transaction.getBankMaintenanceStatus().then(function (response) {
                let maintenanceBankList = response.data;

                if (maintenanceBankList) {
                    for (let i in bank) {
                        for (let key in maintenanceBankList) {
                            if (bank[i].id === maintenanceBankList[key].bankId) {
                                bank[i].regularMaintenance = maintenanceBankList[key].regularMaintenance;
                                bank[i].emergencyMaintenance = maintenanceBankList[key].emergencyMaintenance;
                            }
                        }
                    }
                }

                resolve(bank);
            });
        }
    });
}
export function mu_getMobileWalletShortcutList(vm) {
    if (!vm) {
        return;
    }

    const { portal, seamless } = vm.props;
    const { customTranslationObj, hideVipShortcut, showRebateIcon } = vm.state;
    let mwCustomVIPLink = false;
    let mwVIPLinkInNewWindow = false;
    let shortcutMenuList = [];
    let mobileWalletIcon = {};
    let customShortcutList = null;
    const isFullSeamless = portal.settings.features?.isFullSeamless && seamless?.isSeamless;
    const showHistoryIcon = portal.settings.features?.mobileWalletSettings?.showHistoryIcon;

    if (gu_getNestedValue(portal, 'settings.features.mobileWalletSettings')) {
        let mwSettings = gu_getContentByCurrencyLanguage(vm, portal.settings.features.mobileWalletSettings);
        mobileWalletIcon = gu_getContentByCurrencyLanguage(vm, mwSettings.mobileWalletIcon) || {};

        if (mwSettings.customVIPLink) {
            mwCustomVIPLink = gu_getContentByCurrencyLanguage(vm, mwSettings.customVIPLink);

            if (mwSettings.vipLinkInNewWindow) {
                mwVIPLinkInNewWindow = gu_getContentByCurrencyLanguage(vm, mwSettings.vipLinkInNewWindow);
            }
        }
        customShortcutList = gu_getContentByCurrencyLanguage(vm, mwSettings.customShortcutList) || null;
    }

    if (window.templateLayout === '9') {
        gu_getAffiliateLink(vm);
        shortcutMenuList = [
            {
                index: 0,
                key: 'transfer',
                imgSrc: '/public/html/default_whitelabel/shared-image/home_img/template9/icon-transfer.png',
                translate: (customTranslationObj && customTranslationObj.transfer) || 'settings:settings.tabs.heading.transfer',
                href: '/myaccount/transfer',
                isNavigation: true,
            },
            {
                index: 1,
                key: 'promo',
                imgSrc: '/public/html/default_whitelabel/shared-image/home_img/template9/icon-promo.png',
                translate: (customTranslationObj && customTranslationObj.promotion) || 'global:global.sidebar.promotion.heading2',
                href: '/promotion',
                isNavigation: true,
            },
            {
                index: 2,
                key: 'referral',
                path: '/myaccount/referral',
                imgSrc: '/public/html/default_whitelabel/shared-image/home_img/template9/icon-ref.png',
                translate: (customTranslationObj && customTranslationObj.referral) || 'settings:settings.tabs.heading.referral',
                href: '/myaccount/referral',
                isNavigation: true,
            },
            {
                index: 3,
                key: 'affiliate',
                imgSrc: '/public/html/default_whitelabel/shared-image/home_img/template9/icon-affiliate.png',
                translate: (customTranslationObj && customTranslationObj.affiliate) || 'global:footer.affiliate',
                openAffiliate: true,
                isNavigation: true,
            },
            {
                index: 4,
                key: 'vip',
                imgSrc: '/public/html/default_whitelabel/shared-image/home_img/template9/icon-vip.png',
                translate: (customTranslationObj && customTranslationObj.vip) || 'global:global.menu.vip',
                href: '/vip',
                isNavigation: true,
            },
        ];
    } else {
        shortcutMenuList = [
            {
                key: 'deposit',
                path: '/myaccount/deposit',
                translationKey: 'acc_menu_deposit',
                locale: 'global:global.menu.account.deposit',
                DefaultLabel: 'Deposit',
                checkIfAvailable: true,
                imgPath: '/public/html/images/option-1.png',
                isNavigation: true,
                name: 'deposit',
                svgName: 'D-deposit',
                imgSrc: (mobileWalletIcon && mobileWalletIcon.deposit) || null,
                translate: (customTranslationObj && customTranslationObj.deposit) || 'settings:settings.tabs.heading.deposit',
                href: '/myaccount/deposit',
                checkIfAccountMenuAvailable: true,
            },
            {
                key: 'transfer',
                path: '/myaccount/transfer',
                translationKey: 'acc_menu_transfer',
                locale: 'global:global.sidebar.funds.transfer',
                DefaultLabel: 'Transfer',
                checkIfAvailable: true,
                svgName: 'D-transferall',
                imgPath: '/public/html/images/option-2.png',
                isNavigation: true,
                name: 'transfer',
                imgSrc: (mobileWalletIcon && mobileWalletIcon.transfer) || null,
                translate: (customTranslationObj && customTranslationObj.transfer) || 'settings:settings.tabs.heading.transfer',
                href: '/myaccount/transfer',
                checkIfAccountMenuAvailable: true,
            },
            {
                key: 'withdraw',
                path: '/myaccount/withdraw',
                translationKey: 'acc_menu_withdraw',
                locale: 'global:global.menu.account.withdraw',
                DefaultLabel: 'Withdraw',
                checkIfAvailable: true,
                svgName: 'D-withdraw',
                imgPath: '/public/html/images/option-3.png',
                isNavigation: true,
                name: 'withdraw',
                imgSrc: (mobileWalletIcon && mobileWalletIcon.withdraw) || null,
                translate: (customTranslationObj && customTranslationObj.withdraw) || 'settings:settings.tabs.heading.withdraw',
                href: '/myaccount/withdraw',
                checkIfAccountMenuAvailable: true,
            },
        ];

        if (showHistoryIcon) {
            shortcutMenuList.push({
                key: 'history',
                path: '/myaccount/history/bettingSummary',
                translationKey: 'acc_menu_bettingSummary',
                locale: 'global:global.menu.account.history',
                DefaultLabel: 'Transaction History',
                checkIfAvailable: true,
                svgName: 'D-history',
                imgPath: '/public/html/images/option-4.png',
                isNavigation: true,
                name: 'history',
                imgSrc: (mobileWalletIcon && mobileWalletIcon.history) || null,
                translate: (customTranslationObj && customTranslationObj.history) || 'settings:settings.tabs.heading.withdraw',
                href: '/myaccount/history/bettingSummary',
                checkIfAccountMenuAvailable: true,
            });
        }

        shortcutMenuList.push(
            showRebateIcon
                ? {
                      key: 'rebate',
                      path: '/myaccount/rebate',
                      translationKey: 'mobile_rebate',
                      locale: 'rebate:rebate.instantRebate',
                      DefaultLabel: 'Rebate',
                      isAffiliate: false,
                      svgName: 'D-rebate_ss2',
                      imgPath: '/public/html/default_whitelabel/shared-image/icons/template8/rebate.png',
                      isNavigation: true,
                      name: 'rebate',
                      imgSrc: (mobileWalletIcon && mobileWalletIcon.rebate) || null,
                      translate: (customTranslationObj && customTranslationObj.rebate) || 'rebate:rebate.instantRebate',
                      href: '/myaccount/rebate',
                      checkIfAccountMenuAvailable: true,
                  }
                : {
                      key: 'promotion',
                      path: '/promotion',
                      translationKey: 'mobile_promotion',
                      locale: 'global:global.sidebar.promotion.heading2',
                      DefaultLabel: 'Promotion',
                      isAffiliate: false,
                      svgName: 'D-promotion',
                      imgPath: '/public/html/images/home_img/navbar/mobile_promotion.png',
                      isNavigation: true,
                      name: 'promotion',
                      imgSrc: (mobileWalletIcon && mobileWalletIcon.promotion) || null,
                      translate: (customTranslationObj && customTranslationObj.promotion) || 'global:global.sidebar.promotion.heading2',
                      href: '/promotion',
                  }
        );

        if (hideVipShortcut) {
            shortcutMenuList.push({
                name: 'message',
                svgName: 'D-message',
                imgSrc: (mobileWalletIcon && mobileWalletIcon.message) || null,
                translate: (customTranslationObj && customTranslationObj.message) || 'settings:settings.tabs.heading.message',
                href: '/myaccount/messaging',
                showUnreadMsg: true,
            });
        } else {
            shortcutMenuList.push({
                key: 'vip',
                path: portal?.settings?.features?.mobileWalletSettings?.customVIPLink ? portal?.settings?.features?.mobileWalletSettings?.customVIPLink : '/vip',
                translationKey: 'mobile_vip',
                locale: 'global:global.menu.vip',
                DefaultLabel: 'VIP',
                isAffiliate: false,
                svgName: 'D-vip',
                imgPath: '/public/html/images/home_img/navbar/mobile_vip.png',
                isNavigation: true,
                targetBlank: portal?.settings?.features?.mobileWalletSettings?.vipLinkInNewWindow ?? false,
                name: 'vip',
                imgSrc: (mobileWalletIcon && mobileWalletIcon.vip) || null,
                translate: (customTranslationObj && customTranslationObj.vip) || 'global:global.menu.vip',
                href: mwCustomVIPLink || '/vip',
                url: mwVIPLinkInNewWindow ? mwCustomVIPLink || '/vip' : null,
            });
        }
    }

    if (customShortcutList && customShortcutList.length > 0) {
        customShortcutList.sort(function (obj1, obj2) {
            return obj1.index - obj2.index;
        });
        let k = 0;
        for (let i = 0; i < customShortcutList.length; i++) {
            if ((customShortcutList[i].index || customShortcutList[i].index === 0) && shortcutMenuList[customShortcutList[i].index - k]) {
                for (let key in customShortcutList[i]) {
                    if (key === 'isDisabled' && customShortcutList[i].isDisabled) {
                        shortcutMenuList.splice(customShortcutList[i].index - k, 1);
                        k++;
                    } else {
                        if (
                            !customShortcutList[i].replaceCondition ||
                            (customShortcutList[i].replaceCondition && gu_getNestedValue(vm.props, customShortcutList[i].replaceCondition))
                        ) {
                            shortcutMenuList[customShortcutList[i].index - k][key] = gu_getContentByCurrencyLanguage(vm, customShortcutList[i][key]);
                        }
                    }
                }
            } else {
                for (let key in customShortcutList[i]) {
                    customShortcutList[i][key] = gu_getContentByCurrencyLanguage(vm, customShortcutList[i][key]);
                }
                shortcutMenuList.push(customShortcutList[i]);
            }
        }
    }

    // filter out for affiliate
    if (window.isAffiliate && shortcutMenuList && shortcutMenuList.length > 0) {
        for (let i = 0; i < shortcutMenuList.length; i++) {
            if (shortcutMenuList[i] && shortcutMenuList[i].hideInAffiliate) {
                shortcutMenuList.splice(i, 1);
                i--;
            }
        }
    }
    if (isFullSeamless && Array.isArray(shortcutMenuList) && shortcutMenuList.length > 0) {
        shortcutMenuList = shortcutMenuList.filter((menu) => menu.key !== 'transfer');
    }

    return shortcutMenuList;
}
// Google Auth Settings Related
// reqUpdate is usee for case after email/phone verifiaction, because after verify the api value will changed otherwise won't change
export function mu_getMemberAuthSettings(vm, reqUpdate, type, _callback = null, version = 'v1') {
    const { authSettings, props } = vm;
    if (reqUpdate) {
        getAuthSettings(type, props?.authSettingsReducer?.enableNewOTP);
    } else {
        if (!authSettings) {
            getAuthSettings(type, props?.authSettingsReducer?.enableNewOTP);
        } else {
            vm.props.dispatch(userAction.updateAuthSettings(authSettings));
        }
    }

    function getAuthSettings(type = null, newOTP = false) {
        if (type && newOTP) {
            // need have a handling to define using old or new auth settings
            try {
                Promise.resolve(getAuthSettingsFunction(type, vm, version))
                    .then((res) => {
                        const moduleAuthSettings = mu_getAuthSettingsByModule(
                            {
                                processedData: {
                                    [res?.payload?.authType]: res?.payload?.processedData,
                                },
                                rawData: {
                                    [res?.payload?.authType]: res?.payload?.rawData,
                                },
                            },
                            res?.payload?.authType
                        );
                        _callback?.({ data: moduleAuthSettings });
                    })
                    .catch((err) => {
                        _callback?.({ err: err });
                    });
            } catch {
                _callback();
            }
        }

        // calling old member auth api
        if (!newOTP && !window?.isAffiliate) {
            window.SPL_Member.getAuthSettings()
                .then((res) => {
                    _callback ? _callback({ data: res }) : vm.props.dispatch(userAction.updateAuthSettings(res));
                })
                .catch((err) => {
                    _callback ? _callback({ err: err }) : vm.setState({ authSettingsError: err });
                });
        }
    }
}

export function normalizeAuthMethods(rawAuthMethods) {
    if (!Array.isArray(rawAuthMethods)) return [];
    return rawAuthMethods
        .map((method) => (typeof method === 'string' ? method : method?.type))
        .filter(Boolean);
}

export function mu_getAuthSettingsByModule(authSettingsReducer, type) {
    const processedData = authSettingsReducer?.processedData?.[type] || false;
    const rawData = authSettingsReducer?.rawData?.[type] || false;

    if (!processedData && !rawData) return false;

    const sixpin = rawData?.[MODULE_TYPE.SIX_PIN] || false;
    const otp = processedData?.[OTP_VERIFICATION_METHOD.OTP] || false;
    const ga = rawData?.[OTP_VERIFICATION_METHOD.GA] || false;
    const authMethod = otp?.authMethod || processedData?.authMethod || [];

    // direct check six pin or bind authenticator group
    const sixpinAuthSettings = authSettingsReducer?.rawData?.[window.isAffiliate ? MODULE_TYPE.AFF_SIX_PIN : MODULE_TYPE.SIX_PIN]?.[OTP_VERIFICATION_METHOD.SIX_PIN] || false;
    const bindAuthSettings =
        authSettingsReducer?.rawData?.[window.isAffiliate ? MODULE_TYPE.AFF_BIND_AUTHENTICATOR : MODULE_TYPE.BIND_AUTHENTICATOR]?.[OTP_VERIFICATION_METHOD.GA] || false;

    const checkSixPinByModule = sixpinAuthSettings?.sixPinModule?.includes(type);

    // checking for module group
    const sixPinEnabled = sixpin?.enabled || rawData?.sixPinEnabled || false;
    const sixPinLocked = sixpin?.locked || sixpinAuthSettings?.locked || rawData?.memberSixPinInfo?.sixPinLocked || false;
    // add handling for six pin module check
    const sixPinRegistered = sixpin?.registered || sixpinAuthSettings?.registered || rawData?.memberSixPinInfo?.sixPinRegistered || false;

    return {
        rawData: rawData, // ori data
        processedData: processedData, // filter auth method
        checkSixDigitPin: checkSixPinByModule && sixPinEnabled && (!sixPinRegistered || sixPinLocked), // show six pin notice
        sixPinEnabled: sixPinEnabled,
        sixPinLocked: sixPinLocked,
        sixPinRegistered: sixPinRegistered,
        gaEnabled: ga?.enabled || rawData?.gaEnabled || false,
        gaRegistered: ga?.registered || bindAuthSettings?.registered || rawData?.gaRegistered || false,
        googleAuth: ga?.googleAuth || false,
        otp_feature: (otp && authMethod.length === 0) || (authMethod || []).length > 0 || rawData?.otp_feature || false,
        authMethod: authMethod,
        verificationMethod: sixpin ? OTP_VERIFICATION_METHOD.SIX_PIN : ga ? OTP_VERIFICATION_METHOD.GA : null,
    };
}

function getAuthSettingsFunction(type, vm, version = 'v1') {
    // swtich type return function
    const splConfig = {
        otpOptions: { otpType: type, isPublic: false, isNew: true },
        authSettingsType: type,
        isReqUpdate: true,
        version,
    };

    return vm.props.dispatch(fetchAuthSettings({ splConfig: splConfig }));
}

export function mu_updateGoogleMemberRegisteredTrue(vm) {
    if (vm.props?.authSettingsReducer?.enableNewOTP) {
        return;
    } else {
        let { authSettings } = vm.props.user;
        authSettings.googleMemberRegistered = true;
        vm.props.dispatch(userAction.updateAuthSettings(authSettings));
    }
}

// Google Auth Settings Related End

export function renderDefaultImg(vm, type, defaultImg) {
    const { imgCache } = vm.state;

    if (imgCache[type]) return imgCache[type];

    imgCache[type] = defaultImg;

    vm.setState({ imgCache }, () => {
        return defaultImg;
    });
}

export function mu_validateAccountNumberField(vm, val) {
    if (!(vm && vm.state)) {
        alert('vm not passing in');
        return {};
    }
    const { enablePayID, customTranslationObj } = vm.state;
    const combineCustomTranslationObj = customTranslationObj || vm.props.customTranslationObj;
    let errorRes = '';

    if (val && val !== '') {
        if (enablePayID) {
            if (gu_isNumber(val)) {
                errorRes = '';
            } else {
                let errors = window.SPL_Register.validateEmailFormatWithoutPromise(val);
                if (errors && errors.length > 0) {
                    errorRes = { accountNumber: 'bank:bank.error.payIDFormat' };
                } else {
                    errorRes = '';
                }
            }
        } else {
            const isAllowAlphanumeric = mu_getFilterAllowAlphanumericForAccountNumber(vm);

            if (isAllowAlphanumeric) {
                if (!gu_isValidAlphanumeric(val)) {
                    errorRes = { accountNumber: 'transaction:transaction.withdrawal.invalidAlphanumeric' };
                } else {
                    errorRes = '';
                }
            } else {
                if (gu_isNumber(val)) {
                    errorRes = '';
                } else {
                    errorRes = {
                        accountNumber: 'transaction:transaction.withdrawal.accountNumber-error',
                        phoneNo: 'transaction:transaction.withdrawal.phoneNo-error',
                    };
                }
            }
        }
    } else {
        errorRes = {
            accountNumber:
                combineCustomTranslationObj && combineCustomTranslationObj.customAccountNumberError
                    ? combineCustomTranslationObj.customAccountNumberError
                    : enablePayID
                    ? 'bank:bank.error.payIDRequired'
                    : 'inputHelpBlock:inputHelpBlock.transfer.accountNumberRequired',
            phoneNo: 'inputHelpBlock:inputHelpBlock.transfer.phoneNoRequired',
        };
    }
    return errorRes;
}

export function getReferralBonusCommission(vm, referralSettings) {
    if (gu_getNestedValue(referralSettings, 'referralSetting.showReferralBonusCommission')) {
        window.SPL_Member.getReferralBonusCommission().then((res) => {
            if (res) {
                vm.setState({ referralBonusCommission: res });
            }
        });
    }
}

// Seamless Wallet
// ------- Start Seamless Functions ----
// Get seamless member wallet (96M Wallet, Transfer Wallet, Withdrawable Amount and Non-Withdrawable Amount)
export function mu_getSeamlessMemberWallet(vm) {
    const { user, seamless } = vm.props;

    vm.setState({
        iconLoading: true,
        restoreOnLoad: true,
    });

    // export const seamless_getWallet = async ({seamless, isLogin, dispatch, callback}) => {
    seamless_getWallet({
        seamless: seamless,
        isLogin: user?.isLogin,
        dispatch: vm.props.dispatch,
        callback: () => {
            vm.setState({
                iconLoading: false,
                restoreOnLoad: false,
            });
        },
    });
}

// Check whether member got pending or active promotion applied
export function mu_checkSeamlessMemberPromotionStatus(vm) {
    const { selectedPromotionId } = vm.state;
    const { isSeamless, isSeamlessPromotionExist } = vm.props.seamless;

    if (isSeamless) {
        checkSeamlessMemberPromotionStatus('P,A', isSeamlessPromotionExist).then((res) => {
            let promoStatus = res.data;

            if (promoStatus?.length <= 0) {
                vm.props.dispatch(seamlessAction.isSeamlessPromotionExist(false));
            } else {
                vm.props.dispatch(seamlessAction.seamlessPromotionData(promoStatus));
                vm.props.dispatch(seamlessAction.isSeamlessPromotionExist(true));
            }

            vm.setState({ memberPromotionStatus: promoStatus, isSeamlessLoading: false }, () => {
                if (selectedPromotionId) {
                    mu_getSeamlessPromotionInfo(vm, selectedPromotionId);
                }
            });
        });
    }
}

// Get the selectedPromotionObj Info (showing in the view promo details popup)
export function mu_getSeamlessPromotionInfo(vm, seamlessPromoId) {
    let tempSeamlessPromoInfo = {};
    const { menuSlice, t } = vm.props;
    const { subCategoryMenus } = menuSlice?.processedBaseMenuSettings || {};

    if (seamlessPromoId) {
        getSeamlessPromotionInfo(seamlessPromoId).then((res) => {
            if (res) {
                let seamlessPromoDetails = res.data;
                let categoryProvidersMap = seamlessPromoDetails.categoryProvidersMap;
                let customCategoryProvidersMap = PROVIDER_CATEOGRY_PREFIX;
                let tempCategoryProviderMap = {};

                if (seamlessPromoDetails) {
                    if (seamlessPromoDetails.targetMultiplier) {
                        tempSeamlessPromoInfo.targetMultiplier = seamlessPromoDetails.targetMultiplier;
                    }

                    if (seamlessPromoDetails.maxBonus) {
                        tempSeamlessPromoInfo.maxBonus = seamlessPromoDetails.maxBonus;
                    }

                    if (seamlessPromoDetails.rate) {
                        tempSeamlessPromoInfo.rate = seamlessPromoDetails.rate * 100;

                        if (seamlessPromoDetails.minBonus) {
                            tempSeamlessPromoInfo.minDeposit = seamlessPromoDetails.minBonus / seamlessPromoDetails.rate;
                        }

                        if (seamlessPromoDetails.maxBonus) {
                            tempSeamlessPromoInfo.maxDeposit = seamlessPromoDetails.maxBonus / seamlessPromoDetails.rate;
                        }
                    }

                    if (categoryProvidersMap) {
                        Object.keys(categoryProvidersMap).forEach((key) => {
                            Object.keys(customCategoryProvidersMap).forEach((customKey) => {
                                if (key === customKey) {
                                    tempCategoryProviderMap[customCategoryProvidersMap[customKey]] = categoryProvidersMap[key];
                                    let tempProviderList = [];
                                    tempCategoryProviderMap[customCategoryProvidersMap[customKey]].split(',').forEach((provider) => {
                                        if (subCategoryMenus?.[customCategoryProvidersMap?.[customKey]]?.length > 0) {
                                            subCategoryMenus?.[customCategoryProvidersMap?.[customKey]].forEach((submenuObj) => {
                                                if (submenuObj?.provider === provider) {
                                                    const providerName = t(submenuObj?.content);
                                                    tempProviderList.push(providerName);
                                                }
                                            });
                                        }
                                    });
                                    tempCategoryProviderMap[customCategoryProvidersMap[customKey]] = tempProviderList.join(', ');
                                }
                            });
                        });
                        tempSeamlessPromoInfo.categoryProvidersMap = tempCategoryProviderMap;
                    }
                }
            }

            vm.setState({
                seamlessPromoInfo: tempSeamlessPromoInfo,
            });
        });
    }
}

export function mu_getSeamlessPromotionInfoByPathParam(vm, seamlessPromoId) {
    const { t } = vm.props;
    if (seamlessPromoId) {
        getSeamlessPromotionInfoByPathParam(seamlessPromoId).then((res) => {
            if (res) {
                const data = res.data;
                const modifiedData = {
                    ...data,
                    minDeposit: data.minBonus / data.rate,
                    maxDeposit: data.maxBonus / data.rate,
                    rate: data.rate * 100,
                };

                const providers = (data.providers || []).map((provider) => {
                    return {
                        ...provider,
                        provider: t(`providerName:ProviderName.${provider.provider}`),
                    };
                });
                vm.setState({
                    seamlessPromoInfo: {
                        ...modifiedData,
                        providers,
                    },
                });
            }
        }).catch(() => {
            vm.setState({
                seamlessPromoInfo: null,
            });
        });
    }
}

// Handle promotion change based on selected promotion
export function mu_handlePromoCodeChange(vm, e) {
    if (e) {
        let promoId = gu_massageIndex(e);
        let selectedPromotion = mu_getCorrespondingPromotionObjectByIndex(vm, promoId);
        vm.setState({ selectedPromotionId: promoId, specialPromoCode: '', specialPromo: null }, () => {
            window.usePromoDetailsWithGames ? mu_getSeamlessPromotionInfoByPathParam(vm, promoId) : mu_getSeamlessPromotionInfo(vm, promoId);
        });
        mu_getMinimumAmountForDeposit(vm, selectedPromotion);
    } else {
        vm.setState({ selectedPromotionId: e, specialPromoCode: '', specialPromo: null });
    }
}

// Get the promotion object based on promotion id selected
export function mu_getCorrespondingPromotionObjectByIndex(vm, promoId) {
    return (vm.state.promoList || []).find((data) => {
        return data.id === parseInt(promoId);
    });
}

// Handle special code changes
export function mu_handleSpecialPromoCodeChange(vm, e) {
    let specialPromoCode = gu_massageIndex(e);
    vm.setState({ specialPromoCode: specialPromoCode });
}

// Get the minimum amount for deposit
export function mu_getMinimumAmountForDeposit(vm, promo) {
    let minimumAmount = window.SPL_Transaction.getMinimumAmountForDeposit(promo);

    vm.setState({ minimumAmount: minimumAmount });
}

// Verify the validation of special code
export function mu_verifySpecialPromoCode(vm, promo) {
    const specialPromoCode = gu_massageIndex(promo) || vm.state?.specialPromoCode;
    if (specialPromoCode) {
        let login = vm.props.user.account;
        let depositAmount = vm.state.fields['amount'];

        window.SPL_Member.verifySpecialPromotionsCode(login, specialPromoCode, depositAmount).then((res) => {
            let specialPromoInfo = res?.specialPromo;
            let depositAmount = vm.state.fields['amount'];
            if (res?.isValidPromo && !res?.specialPromo?.exceedMaxBonus) {
                depositAmount = res.isValidSpecialPromoAmount ? depositAmount : '';
            }

            vm.setState(
                {
                    isValidSpecialPromoCode: res.isValidPromo,
                    fields: {
                        amount: depositAmount,
                    },
                    minimumAmount: res.minimumAmount,
                    specialPromoInfo: specialPromoInfo,
                },
                () => {
                    if (vm.state.isValidSpecialPromoCode || res?.isValidPromo) {
                        vm.setState({ specialPromo: res.specialPromo });
                    }

                    if (depositAmount && depositAmount >= vm.state.minimumAmount) {
                        vm.setState({ disabledDepositButton: false });
                    } else {
                        vm.setState({ disabledDepositButton: true });
                    }
                }
            );
        });
    }
}

export function mu_loadProviders(loadAsync, vm) {
    return (callback) => {
        vm.setState({ iconLoading: true });
        const { language } = vm.props;

        window.SPL_Provider.getAllProviderWalletList(language, true, vm.props)
            .then((data) => {
                const { sportbook, esport, casino, slots, poker, lottery, fishing, games, cockfight, fastgames } = vm.state;
                let tempProviderList = data.providerList;
                let providerList = [];
                let tempCategoryList = { S: sportbook, ES: esport, C: casino, SL: slots, P: poker, L: lottery, F: fishing, G: games, CF: cockfight, FG: fastgames };

                tempProviderList = tempProviderList.filter((a) => a.provider !== null);

                tempProviderList.forEach((provider) => {
                    // provider.name = `${commonUtil.getCorrectProviderName(provider)}`;
                    providerList.push(provider);
                });

                providerList = providerList.slice(0).sort(function (a, b) {
                    return a['provider'] > b['provider'] ? 1 : a['provider'] < b['provider'] ? -1 : 0;
                });

                vm.props.dispatch(seamlessAction.getSeamlessAllProviderWallets(providerList));

                for (let k = 0; k < Object.keys(tempCategoryList).length; k++) {
                    let categories = Object.keys(tempCategoryList)[k];
                    let providerObj = false;

                    providerObj = tempCategoryList[categories].some(function (provider) {
                        let validateProvider = providerList.filter((a) => {
                            return a.provider === provider;
                        });

                        return validateProvider.length > 0;
                    });

                    if (!providerObj) {
                        tempCategoryList[categories] = [];
                    }
                }

                vm.setState({
                    categoryList: tempCategoryList,
                    providerList: providerList,
                });
            })
            .then(() => {
                if (loadAsync) {
                    mu_loadAsyncProviderWallet(vm, true, callback);
                }
            });
    };
}

export function mu_loadAsyncProviderWallet(vm, check, callback) {
    const { user } = vm.props;
    window.SPL_Provider.loadAsyncProviderWallet(check, vm.props, true, user?.account?.id).then((seamlessProviderWallet) => {
        if (seamlessProviderWallet.requireToReCallApi) {
            setTimeout(() => {
                mu_loadAsyncProviderWallet(vm, false);
            }, 1000);
        } else {
            mu_updateSeamlessProviderList(vm, seamlessProviderWallet.providerList, callback);
        }
    });
}

export function mu_updateSeamlessProviderList(vm, seamlessProviderWalletList, callback) {
    const { providerWallets } = vm.props.seamless;
    let seamlessProviderList = {};

    if (seamlessProviderWalletList) {
        Object.keys(seamlessProviderWalletList).forEach((seamlessProviderWalletCategory) => {
            let tempSeamlessProviderList = [];
            seamlessProviderWalletList[seamlessProviderWalletCategory].forEach((seamlessProviderWallet) => {
                providerWallets.filter((providerList) => {
                    if (providerList.provider === seamlessProviderWallet) {
                        tempSeamlessProviderList.push(providerList);
                    }
                    return providerList;
                });
            });

            if (tempSeamlessProviderList && tempSeamlessProviderList.length > 0) {
                seamlessProviderList[seamlessProviderWalletCategory] = tempSeamlessProviderList;
            }
        });
    }

    vm.props.dispatch(seamlessAction.updateSeamlessProviderWallets(seamlessProviderList));
    callback && callback();
}

export function mu_loadMenuSettings(vm) {
    return (callback) => {
        const { language, menuSlice } = vm.props;
        const { categoryList } = vm.state;
        let resJson = {};
        let finalJson = {};
        let tempCategoryList = categoryList;
        let isIndex = false;
        for (let i = 0; i < Object.keys(tempCategoryList).length; i++) {
            let submenu = gu_deepCopy(menuSlice?.processedBaseMenuSettings?.subCategoryMenus?.[Object.keys(tempCategoryList)[i]]) || [];
            // window.SPL_Content.getSubmenu(language.countryLanguageKey, 'web', Object.keys(tempCategoryList)[i], user.account).then((submenu) => {
            for (let j = 0; j < submenu.length; j++) {
                if (submenu[j].name.includes('index')) {
                    isIndex = true;
                    submenu.splice(j, 1);
                    window.SPL_Content.getDisplayIndexCategory(language.countryLanguageKey, 'web', Object.keys(tempCategoryList)[i]).then((data) => {
                        submenu = data.concat(submenu);
                        resJson = _dataFilter(submenu, j, resJson);
                        isIndex = false;
                        _handleRemainingMenu(tempCategoryList, resJson, finalJson);
                    });
                } else {
                    resJson = _dataFilter(submenu, j, resJson);
                    break;
                }
            }

            if (isIndex === false && i + 1 === Object.keys(tempCategoryList).length) {
                _handleRemainingMenu(tempCategoryList, resJson, finalJson);
            }
            // });
        }
        callback && callback();
    };

    function _dataFilter(submenu, j, resJson) {
        let data = submenu;
        resJson[submenu[j].category] = [];
        for (let k = 0; k < data.length; k++) {
            if (!data[k].disableFromTransferOption) {
                resJson[submenu[j].category].push(data[k].provider);
            }
        }
        return resJson;
    }

    function _handleRemainingMenu(tempCategoryList, resJson, finalJson) {
        for (let keys in tempCategoryList) {
            finalJson[keys] = [];
            for (let i = 0; i < Object.keys(resJson).length; i++) {
                if (keys === Object.keys(resJson)[i]) {
                    finalJson[keys] = resJson[Object.keys(resJson)[i]];
                }
            }
        }

        //remove dupicate game providers for those merchant stil using game in submenu
        for (let keys in finalJson) {
            let uniqueArray = [];
            uniqueArray = finalJson[keys].filter((a, index) => {
                return finalJson[keys].indexOf(a) === index;
            });
            finalJson[keys] = uniqueArray;
        }

        vm.props.dispatch(gameAction.updateMerchantProviderCategory(finalJson));
        vm.setState({ categoryList: finalJson });
    }
}

export function mu_renderCategoryProvider(vm, category) {
    const { selectedCategory } = vm.state;

    if (selectedCategory === category || !category) {
        vm.setState({ selectedCategory: false });
    } else {
        vm.setState({ selectedCategory: category });
    }
}

export function mu_applyFreebetSeamlessPromotion(vm, freebetPromoCode) {
    const { t } = vm.props;
    gu_togglePopup(vm, 'freebetConfirmation');

    window.SPL_Member.applyFreebetSeamlessPromotion(freebetPromoCode).then((data) => {
        if (data.code === '10000') {
            notification.showNotification('success', t('settings:settings.freebet.success', 'Promotion code has been applied successfully.'));
        } else if (data.code === 'SW20009') {
            notification.showNotification('error', t('settings:settings.freebet.pending', 'Member has pending or active promotion.'));
        } else if (data.code === 'SW20010') {
            notification.showNotification('error', t('settings:settings.freebet.invalid-promotion', 'Invalid Promotion.'));
        } else if (data.code === 'SW20012') {
            notification.showNotification('error', t('settings:settings.freebet.phone-verification', 'Phone verification requires'));
        } else if (data.code === 'SW20013') {
            notification.showNotification('error', t('settings:settings.freebet.welcome-bonus', 'Welcome Bonus only can apply once.'));
        } else if (data.code === 'SW20014') {
            notification.showNotification('error', t('settings:settings.freebet.reached-max', 'Reached max deposit.'));
        } else if (data.code === 'SW20015') {
            notification.showNotification('error', t('settings:settings.freebet.min-deposit', 'Min deposit Requires.'));
        } else if (data.code === 'SW20017') {
            notification.showNotification('error', t('settings:settings.freebet.fully-claimed', 'This promotion is fully claimed.'));
        } else {
            notification.showNotification('error', t('settings:settings.freebet.contact-system-admin', 'Please contact system admin.'));
        }
    });
}

export function mu_openSmsVerificationDialog(vm, continueSubmitCallback) {
    vm.setState({
        phoneVerificationDialogIsShow: true,
        phoneVerificationDialogClosedCallback: continueSubmitCallback,
    });
}

export function mu_closePhoneVerificationDialog(vm) {
    vm.setState({ phoneVerificationDialogIsShow: false });
}

export async function mu_handleFreeBetApplying(vm, e) {
    let target = '';
    let freebetPromoCode = '';
    target = e?.target?.closest('a');
    let href = target?.href;

    // Used for fifa redirection
    // Can delete after fifa ends
    if (href && target?.classList?.contains('fifa')) {
        e.preventDefault();
        mu_externalAuthRedirect(href);
        return;
    }

    if (!href || !href?.includes('promoID')) {
        return;
    }

    const promoId = href.split('-').pop();

    e.preventDefault();

    //Back end retrieve the promo information based on the promo ID
    const res = await window.SPL_Member.getSeamlessPromoBasicInfo(promoId);

    const isRequiredPhoneVerification = !!res?.phoneVerification;
    // Phone verification setting is off => continue with claim popup
    if (!isRequiredPhoneVerification) {
        continueFreebetApplying(vm, href);
        return;
    }

    // Phone verification setting is on => user need to verify phone number
    window.SPL_Member.getPhoneRequiredVerification().then(function (isReqVerification) {
        if (isReqVerification) {
            mu_openSmsVerificationDialog(vm, () => continueFreebetApplying(vm, href));
        } else {
            continueFreebetApplying(vm, href);
        }
    });

    function continueFreebetApplying(vm, href) {
        if (href && href.includes('promoID')) {
            freebetPromoCode = href.split('-').pop();

            vm.setState({ freebetPromoCode: freebetPromoCode }, () => {
                if (freebetPromoCode) {
                    gu_togglePopup(vm, 'freebetConfirmation');
                }
            });
        } else {
            window.open(href);
        }
    }
}

// Used for fifa redirection
// Can delete after fifa ends
export function mu_externalAuthRedirect(href) {
    if (!href) return;

    const token = getCookie('t');
    const langCode = window.location.pathname.split('/').filter(Boolean)[0] || '';

    let redirectUrl = href.replace(/\/+$/, '');

    if (token) {
        redirectUrl = `${redirectUrl}/external-login-success` + `?t=${encodeURIComponent(token)}` + `&langCode=${encodeURIComponent(langCode)}`;
    }

    window.location.href = redirectUrl;
}

// Apply Seamless Crypto Promotion
export function mu_applySeamlessCryptoPromotion(vm) {
    const { specialPromo, promoList, selectedPromotionId, compSettings, selectedChain } = vm.state;
    const { language } = vm.props;
    let seamlessPromoObj = null;
    let seamlessPromoId = null;
    let seamlessPromoCode = null;

    if (specialPromo) {
        seamlessPromoObj = specialPromo;
        if (seamlessPromoObj) {
            seamlessPromoId = seamlessPromoObj.id;
            seamlessPromoCode = seamlessPromoObj.code;
        }
    } else if (promoList && promoList.length > 0 && selectedPromotionId) {
        seamlessPromoObj = mu_getCorrespondingPromotionObjectByIndex(vm, selectedPromotionId);
        if (seamlessPromoObj) {
            seamlessPromoId = seamlessPromoObj.id;
            seamlessPromoCode = seamlessPromoObj.code;
        }
    }

    let params = {
        bank: selectedChain && selectedChain.code,
        methodCode: selectedChain && selectedChain.code,
        merchantCode: window.merchantCode,
        portalLanguage: language && language.countryLanguageKey,
        merchantBankId: selectedChain && selectedChain.id,
        amount: null,
        seamlessPromoId: seamlessPromoId,
        promoCode: seamlessPromoCode,
    };

    if (compSettings && compSettings.isDisablePromoCode && seamlessPromoObj && seamlessPromoObj.isPhoneVerification) {
        window.SPL_Member.getPhoneRequiredVerification().then(function (isReqVerification) {
            // if require phone verification, update status to S
            // frontend need to handle open sms popup to verify phone
            // before proceed
            if (isReqVerification) {
                mu_openSmsVerificationDialog(vm, () => {
                    checkSeamlessPromotionValidate(vm);
                });
            } else {
                checkSeamlessPromotionValidate(vm);
            }
        });
    } else {
        proceedSubmit(vm);
    }

    function checkSeamlessPromotionValidate(vm) {
        window.SPL_Member.checkSeamlessPromotionValidate(seamlessPromoObj).then((status) => {
            if (!status) {
                gu_togglePopup(vm, 'riskRestriction');
            } else {
                proceedSubmit(vm);
            }
        });
    }

    function proceedSubmit(vm) {
        const { promoList, selectedPromotionId } = vm.state;

        window.SPL_Member.applySeamlessCryptoPromotion(params).then((res) => {
            if (res && res.status === 'S') {
                let promotionQueueData = res.data;
                let tempSpecialPromoCode = '';
                let tempSelectedPromotionId = selectedPromotionId;
                let pendingPromotionQueue = false;
                let isPendingSpecialCode = false;
                let isCryptoPromoQueue = false;

                if (promotionQueueData) {
                    pendingPromotionQueue = true;
                    if (promoList?.length > 0) {
                        for (let i = 0; i < promoList.length; i++) {
                            if (promoList[i].id === promotionQueueData.seamlessPromotionId && promoList[i].code === promotionQueueData.promotionCode) {
                                tempSelectedPromotionId = promotionQueueData.seamlessPromotionId;
                                isPendingSpecialCode = false;
                                if (promotionQueueData.type === 'C') {
                                    isCryptoPromoQueue = true;
                                }
                            }
                        }

                        if (!tempSelectedPromotionId) {
                            tempSpecialPromoCode = promotionQueueData.promotionCode;
                            isPendingSpecialCode = true;
                            if (promotionQueueData.type === 'C') {
                                isCryptoPromoQueue = true;
                            }
                        }
                    } else {
                        tempSpecialPromoCode = promotionQueueData.promotionCode;
                        isPendingSpecialCode = true;
                        if (promotionQueueData.type === 'C') {
                            isCryptoPromoQueue = true;
                        }
                    }
                    vm.props.dispatch(seamlessAction.isSeamlessPromotionExist(true));
                } else {
                    pendingPromotionQueue = false;
                }

                // vm.props.dispatch(seamlessAction.getSeamlessPromotionQueueData(promotionQueueData));

                vm.setState(
                    {
                        pendingPromotionQueue: pendingPromotionQueue,
                        isPendingSpecialCode: isPendingSpecialCode,
                        isCryptoPromoQueue: isCryptoPromoQueue,
                        specialPromoCode: tempSpecialPromoCode,
                        selectedPromotionId: !isPendingSpecialCode ? promotionQueueData?.seamlessPromotionId || tempSelectedPromotionId : '',
                    },
                    () => {
                        if (vm.state.selectedPromotionId) {
                            mu_getSeamlessPromotionInfo(vm, vm.state.selectedPromotionId);
                        }
                    }
                );
            } else {
                vm.setState({ pendingPromotionQueue: false });
                notification.showNotification('error', vm.props.t(res));
            }
        });
    }
}

// Cancel Seamless Pending Promotion Queue
export function mu_cancelSeamlessPendingPromoQueue(vm) {
    window.SPL_Member.cancelSeamlessPendingPromoQueue().then((res) => {
        if (res.status === 'S') {
            let promotionQueueData = '';
            vm.props.dispatch(seamlessAction.getSeamlessPromotionQueueData(promotionQueueData));

            vm.setState({
                pendingPromotionQueue: false,
                selectedPromotionId: '',
                specialPromoCode: '',
            });
        } else {
            notification.showNotification('error', vm.props.t(res));
        }
    });
}

// Used to check the promotion applied status in crypto page
// export function mu_checkSeamlessPromotionQueue(vm) {
//     const { seamlessPromotionQueueData, isSeamless, isSeamlessPromotionExist } = vm.props.seamless;
//     let { promoList, selectedPromotionId } = vm.state;

//     const _processQueueData = (res) => {
//         let promotionQueueData = res;
//         let tempSpecialPromoCode = '';
//         let tempSelectedPromotionId = selectedPromotionId;
//         let pendingPromotionQueue = false;
//         let isPendingSpecialCode = false;
//         let isCryptoPromoQueue = false;

//         if (promotionQueueData) {
//             pendingPromotionQueue = true;
//             if (promoList && promoList.length > 0) {
//                 for (let i = 0; i < promoList.length; i++) {
//                     if (promoList[i].id === promotionQueueData.seamlessPromotionId && promoList[i].code === promotionQueueData.promotionCode) {
//                         tempSelectedPromotionId = promotionQueueData.seamlessPromotionId;
//                         isPendingSpecialCode = false;
//                         if (promotionQueueData.type === 'C') {
//                             isCryptoPromoQueue = true;
//                         }
//                     }
//                 }

//                 if (!tempSelectedPromotionId) {
//                     tempSpecialPromoCode = promotionQueueData.promotionCode;
//                     isPendingSpecialCode = true;
//                     if (promotionQueueData.type === 'C') {
//                         isCryptoPromoQueue = true;
//                     }
//                 }
//             } else {
//                 tempSpecialPromoCode = promotionQueueData.promotionCode;
//                 isPendingSpecialCode = true;
//                 if (promotionQueueData.type === 'C') {
//                     isCryptoPromoQueue = true;
//                 }
//             }
//             vm.props.dispatch(seamlessAction.isSeamlessPromotionExist(true));
//         } else {
//             pendingPromotionQueue = false;
//         }

//         vm.props.dispatch(seamlessAction.getSeamlessPromotionQueueData(promotionQueueData));

//         vm.setState(
//             {
//                 pendingPromotionQueue: pendingPromotionQueue,
//                 isPendingSpecialCode: isPendingSpecialCode,
//                 isCryptoPromoQueue: isCryptoPromoQueue,
//                 specialPromoCode: tempSpecialPromoCode,
//                 selectedPromotionId: !isPendingSpecialCode ? promotionQueueData?.seamlessPromotionId || tempSelectedPromotionId : '',
//             },
//             () => {
//                 if (vm.state.selectedPromotionId) {
//                     mu_getSeamlessPromotionInfo(vm, vm.state.selectedPromotionId);
//                 }
//             }
//         );

//         if (!pendingPromotionQueue) {
//             mu_checkSeamlessMemberPromotionStatus(vm);
//         }
//     };

//     if (isSeamless) {
//         if (seamlessPromotionQueueData || isSeamlessPromotionExist === null || isSeamlessPromotionExist) {
//             window.SPL_Member.checkSeamlessPromotionQueue().then((res) => {
//                 _processQueueData(res);
//             });
//         } else {
//             _processQueueData(seamlessPromotionQueueData);
//         }
//     }
// }

export function mu_initialGetSeamlessPromotions(vm, setDefaultPromotionId = true) {
    const { language, t, screen } = vm.props;
    const { isSeamless, isSeamlessPromotionExist, isApplyingPromotionId, seamlessPromotionQueueData } = vm.props.seamless;
    let promotionList = [];
    let languageKey = language.key.toUpperCase();
    if (languageKey === 'ZH-CN') {
        languageKey = 'ZH';
    }

    let platform = null;
    if (window.portalSettings?.features?.seamless?.getPromoCodeByPlatform) {
        if (window.SPL_LiteApp.isLiteApp()) {
            platform = 'A';
        } else if (screen.viewType === 'web') {
            platform = 'W';
        } else {
            platform = 'M';
        }
    }

    if (isSeamless) {
        vm.setState({ isSeamlessLoading: true }, () => {
            const _getSeamlessPromotions = async () => {
                let retries = 0;
                const fetchWithRetry = async () => {
                    try {
                        const response = await getSeamlessPromotions(languageKey, 'DEPOSIT', isSeamlessPromotionExist, platform);
                        switch (response?.code) {
                            case '10000':
                                return response?.data;

                            default:
                                break;
                        }
                    } catch (error) {
                        switch (error?.data?.code) {
                            case 'SW20020':
                                retries++;
                                if (retries < 3) {
                                    return fetchWithRetry();
                                }
                                break;

                            default:
                                break;
                        }
                    }
                };

                return fetchWithRetry();
            };

            let checkSeamlessPromotionQueue = new Promise((resolve) => {
                // checked condition should be no need. seamlessPromotionQueueData condition is no use
                // Because isSeamlessPromotionExist default will be null, or true. Hence, every time will fire API on trigger
                if (seamlessPromotionQueueData || isSeamlessPromotionExist === null || isSeamlessPromotionExist) {
                    window.SPL_Member.checkSeamlessPromotionQueue().then((res) => resolve(res));
                } else {
                    resolve(seamlessPromotionQueueData);
                }
            });

            return new Promise(() => {
                Promise.all([_getSeamlessPromotions(), checkSeamlessPromotionQueue]).then(([promoList, tempPromotionQueueData]) => {
                    let tempSelectedPromotionId = '';
                    let tempSpecialPromoCode = '';
                    let pendingPromotionQueue = false;
                    let isPendingSpecialCode = false;
                    let isCryptoPromoQueue = false;
                    let promotionQueueData = { ...tempPromotionQueueData } || null;
                    let promoQueueBonusNameJsonData = null;

                    if (promotionQueueData?.bonusName) {
                        promoQueueBonusNameJsonData = JSON.parse(promotionQueueData.bonusName);
                        promotionQueueData.bonusName = promoQueueBonusNameJsonData?.[languageKey.toLowerCase()]?.name || promoQueueBonusNameJsonData?.en?.name;
                    }
                    if (promoList?.length > 0) {
                        for (let i = 0; i < promoList.length; i++) {
                            promotionList.push(promoList[i]);
                        }
                    }

                    // Check whether the promotion applied in promotion page is valid
                    // If valid, redirect to deposit page and pre-select applied promotion
                    // If no valid, show error msg
                    if (promotionList?.length >= 0 && isApplyingPromotionId) {
                        let checkedValidPromo = promotionList.some((promoObj) => promoObj.id === isApplyingPromotionId);

                        if (checkedValidPromo) {
                            tempSelectedPromotionId = isApplyingPromotionId;
                        }
                    } else if (promotionList?.length <= 0 && isApplyingPromotionId) {
                        notification.showNotification('error', t('transaction:transaction.transfer.promocode-invalid', 'Invalid Promo Code'));
                    }

                    if (promotionQueueData && Object.keys(promotionQueueData).length > 0) {
                        pendingPromotionQueue = true;
                        if (promotionList?.length > 0) {
                            for (let i = 0; i < promotionList.length; i++) {
                                if (
                                    !promotionQueueData.specialCode ||
                                    (promotionList[i].id === promotionQueueData.seamlessPromotionId && promotionList[i].code === promotionQueueData.promotionCode)
                                ) {
                                    tempSelectedPromotionId = promotionQueueData.seamlessPromotionId;
                                    isPendingSpecialCode = false;
                                    if (promotionQueueData.type === 'C') {
                                        isCryptoPromoQueue = true;
                                    }
                                }
                            }

                            if (promotionQueueData.specialCode && !tempSelectedPromotionId) {
                                tempSpecialPromoCode = promotionQueueData.promotionCode;
                                isPendingSpecialCode = true;
                                if (promotionQueueData.type === 'C') {
                                    isCryptoPromoQueue = true;
                                }
                            }
                        } else {
                            tempSpecialPromoCode = promotionQueueData.promotionCode;
                            isPendingSpecialCode = true;
                            if (promotionQueueData.type === 'C') {
                                isCryptoPromoQueue = true;
                            }
                        }
                        vm.props.dispatch(seamlessAction.isSeamlessPromotionExist(true));
                    } else {
                        pendingPromotionQueue = false;
                    }

                    vm.props.dispatch(seamlessAction.getSeamlessPromotionQueueData(promotionQueueData));

                    vm.setState(
                        {
                            promoList: promotionList,
                            selectedPromotionId: setDefaultPromotionId
                                ? !isPendingSpecialCode
                                    ? promotionQueueData?.seamlessPromotionId || tempSelectedPromotionId
                                    : ''
                                : '',
                            specialPromoCode: tempSpecialPromoCode,
                            specialPromo: null,
                            isValidSpecialPromoCode: false,
                            pendingPromotionQueue: pendingPromotionQueue,
                            isPendingSpecialCode: isPendingSpecialCode,
                            isCryptoPromoQueue: isCryptoPromoQueue,
                        },
                        () => {
                            if (vm.state.selectedPromotionId) {
                                mu_getSeamlessPromotionInfo(vm, vm.state.selectedPromotionId);
                            }

                            if (!pendingPromotionQueue) {
                                mu_checkSeamlessMemberPromotionStatus(vm);
                            } else {
                                vm.setState({ isSeamlessLoading: false });
                            }
                        }
                    );
                });
            });
        });
    }
}

export function mu_getFilterAllowAlphanumericForAccountNumber(vm) {
    let { selectedBankObj, unOwnedBankList, fields } = vm.state || {};
    const { user, paymentGatewaySetting } = vm.props || {};
    const currency = user?.account?.currency;

    if (!selectedBankObj) {
        selectedBankObj = unOwnedBankList?.[fields?.selectedBankIndex];
    }

    const allowAlphanumeric = paymentGatewaySetting?.allowNumericAlphabetForAccountNumber;
    const filterRegionAllowAlphanumeric = allowAlphanumeric?.[currency] || allowAlphanumeric?.default;
    return filterRegionAllowAlphanumeric?.findIndex((code) => code === selectedBankObj?.code || code === selectedBankObj?.bankCode) > -1;
}

export function mu_getAllowAlphanumeric(vm, bankCodeSelected, type = 'withdrawal') {
    const { user, portal } = vm.props;
    const currency = user?.account?.currency;

    const dynamicConfig = {
        withdrawal: 'settings.features.withdrawalSettings.allowNumericAlphabetForAccountNumber',
        bankDetail: 'settings.allowNumericAlphabetForAccountNumber',
    };
    const allowAlphanumericConfig = gu_getNestedValue(portal, dynamicConfig[type]);

    if (!currency || !bankCodeSelected || !allowAlphanumericConfig) {
        return false;
    }

    const allowedBanks = allowAlphanumericConfig[currency];
    return Array.isArray(allowedBanks) && allowedBanks.includes(bankCodeSelected);
}

export function mu_checkMemberVerification(vm, menu) {
    const { user, portal } = vm.props;

    let settingsConfiguration = gu_getNestedValue(portal, 'settings.features.settingsConfiguration');
    let checkEmailOrPhoneIsVerified = gu_filterCommonKey(settingsConfiguration, 'checkEmailOrPhoneIsVerified', { baseOnUserCurrency: true });

    let checkIsVerified = null;
    if (
        checkEmailOrPhoneIsVerified &&
        checkEmailOrPhoneIsVerified.length > 0 &&
        (checkEmailOrPhoneIsVerified.includes(menu.id) > 0 || checkEmailOrPhoneIsVerified.includes(menu.name) > 0)
    ) {
        let checkSettingsIsVerified = gu_getNestedValue(settingsConfiguration, 'memberVerificationSettings.checkSettingsIsVerified') || ['phoneVerified', 'emailVerified'];
        if (checkSettingsIsVerified) {
            checkSettingsIsVerified.map((setting) => {
                if (gu_getNestedValue(settingsConfiguration, 'memberVerificationSettings.checkAllVerificationSettings')) {
                    if (gu_getNestedValue(user, 'verifications.personal') && user.verifications.personal[setting] && checkIsVerified !== false) {
                        checkIsVerified = true;
                    } else {
                        checkIsVerified = false;
                    }
                } else if (gu_getNestedValue(user, 'verifications.personal') && user.verifications.personal[setting] && checkIsVerified !== false) {
                    checkIsVerified = true;
                }

                return checkIsVerified;
            });
        }
    } else {
        checkIsVerified = true;
    }
    return checkIsVerified;
}

export async function mu_getExternalRewardMemberToken(menu, isLogin = true, countryLanguageKey) {
    if (!isLogin && menu?.urlLink) {
        return filterCommonKey(menu.urlLink);
    }

    try {
        const data = await window.SPL_Member.getExternalRewardMemberToken();
        const { rewardsUrl, token } = data || {};

        if (!rewardsUrl || !token) {
            throw new Error('Invalid reward data received');
        }

        const separator = rewardsUrl.endsWith('/') ? '' : '/';
        const locale = countryLanguageKey || '';

        return `${rewardsUrl}${separator}${locale}?token=${encodeURIComponent(token)}`;
    } catch (error) {
        console.error('Failed to get external reward member token:', error);
        throw error;
    }
}

export function mu_checkMyVipIsEnabled(vm) {
    let props = vm.props;
    let showMyVipTab = false;
    const vipSystemEnabled = featureConfigClient.getFlag('global', MASTER_SWITCH_MODULE_TYPE.VIP_SYSTEM, false);

    return new Promise(function (resolve) {
        if (gu_getNestedValue(vm.props, 'myVip.isEnabled') === null && vipSystemEnabled) {
            props
                .dispatch(myVipAction.checkVipTabIsEnabled())
                .then((data) => {
                    resolve(data);
                })
                .catch(() => {
                    resolve(false);
                });
        } else {
            showMyVipTab = gu_getNestedValue(vm.props, 'myVip.isEnabled');
            resolve(showMyVipTab);
        }
    });
}

// use token to login.
// Currently use case is for after reset passowrd successfully, because reset password don't need username
export function mu_loginByToken(props, jwtToken, callback) {
    if (jwtToken) {
        window.SPL_Auth.setToken(jwtToken);
        props.dispatch(userAction.isAuthenticated()).then((account) => {
            callback && callback(account || null);
        });
    }
}

export async function mu_loginRedirectPage(props = {}) {
    const { screen, routeProps, portal, language } = props;

    async function getCountryLanguageKeyPath() {
        const countryLanguage = language.countryLanguageKey?.toLowerCase().replace('_', '-');
        const vm = { props };
        const langPath = await core.getCurrentLanguage(false, false, vm, languageAction);
        const remainCurrentDomainLangKey = gu_getNestedValue(portal, 'settings.features.remainCurrentDomainLangKey');
        const currentDomainLanguageKey = countryLanguage?.toLowerCase().replace('_', '-');
        const finalCountryLanguageKey = remainCurrentDomainLangKey ? currentDomainLanguageKey : langPath.computeLanguage || countryLanguage;
        let isHideLangPathUrl = gu_getNestedValue(portal, 'settings.features.hideLangPathUrl');

        if (typeof isHideLangPathUrl === 'object') {
            isHideLangPathUrl = !!isHideLangPathUrl[langPath.computeLanguage];
        }

        return isHideLangPathUrl ? '' : finalCountryLanguageKey ? `/${finalCountryLanguageKey}` : '';
    }
    const countryLanguageKeyPath = await getCountryLanguageKeyPath(); // return /en-my, /en-sg, ...etc

    if (screen.isMobile) {
        const homeUrl = gu_getDefaultUrl(routeProps);
        const dynamicHomeUrl = homeUrl && typeof homeUrl === 'string' ? homeUrl : '/';
        window.location.href = countryLanguageKeyPath + dynamicHomeUrl;
    } else {
        const depositPageUrl = '/myaccount/deposit';
        window.location.href = countryLanguageKeyPath + depositPageUrl;
    }
}

export function mu_insertRebateIcon(list = []) {
    if (list && list.length > 0) {
        const rebateObject = {
            id: 'rebate',
            path: '/myaccount/rebate',
            svgIcon: 'D-rebate_ss2',
            svgType: 'SVGMyAcc',
            text: 'rebate:rebate.instantRebate',
        };

        const rebateIndex = list.findIndex((item) => item.id === 'rebate');
        if (rebateIndex === -1) {
            list.push(rebateObject);
        }

        return list;
    }
    return [];
}

export function mu_getEnableGrandtotal(vm, historyType) {
    const { portal } = vm.props;
    let _isEnableGrandtotal =
        gu_filterCommonKey(portal, 'settings.features.enableGrandtotalTabs') && gu_filterCommonKey(portal, 'settings.features.enableGrandtotalTabs').includes(historyType);

    return _isEnableGrandtotal;
}

export function mu_getReferralSettings(vm, _callback = null) {
    const { referralProps, flagsmith } = vm.props;

    // TODO: will remove isPreventCallApiReferralDetails flagsmith when production is stable
    const { isPreventCallApiReferralDetails } = flagsmith?.depositCashmarketApi || {};
    const allowCallback = Object.keys(referralProps.referralDetail || {}).length > 0 && isPreventCallApiReferralDetails;

    return new Promise((resolve) => {
        if (referralProps && referralProps.referralSetting && referralProps.referralDetail && allowCallback) {
            _callback && _callback(referralProps);
        } else if (referralProps && referralProps.isUpdated) {
            const { enableReferralProgram, enableReferralCommProgram, isMultiTierReferral, disableMemberBecomeReferral } = referralProps;
            mu_initSP2ReferralSetting(vm, enableReferralProgram, enableReferralCommProgram, _callback, isMultiTierReferral, disableMemberBecomeReferral);
        } else {
            mu_getReferralTypeEnabled(vm, (_resolve, enableReferralProgram, enableReferralCommProgram, isMultiTierReferral, disableMemberBecomeReferral) => {
                mu_initSP2ReferralSetting(vm, enableReferralProgram, enableReferralCommProgram, _callback, isMultiTierReferral, disableMemberBecomeReferral);
                resolve && _resolve();
            });
        }
    });
}

export function mu_getVIPTiers(depositProgress, currentMemberLevel, language) {
    // Check the current member level
    switch (currentMemberLevel) {
        case 'PLATINUM':
            // If Platinum, return 'By invitation' immediately
            return 'vip:vip.byInvitation';
        case 'GOLD':
            // If Gold, and currency is THB, return 'By invitation'
            if (language?.currentLanguage?.currency === 'THB') {
                return 'vip:vip.byInvitation';
            }
            // Don't forget to break after each case
            return depositProgress;
        default:
            // For any other case, return the depositProgress
            return depositProgress;
    }
}

export function mu_getMiniGameLinkAfterLogin(props, _callback = false) {
    if (!props) return false;

    let wi = window.open('about:blank', '_blank');
    window.SPL_Member.getMerchantMiniGameLink().then((res) => {
        core.portalIsLoading(props, false);
        let url = res?.data?.url || res?.data?.login_url || null;
        if (url) {
            if (_callback) {
                _callback(url);
            } else {
                wi.location.href = url;
            }
        } else {
            wi.close();
        }
    });
}

export function mu_getRequestAuthAttemptInfo(otpType, data, isPublic = false) {
    const splConfig = {
        otpOptions: { isPublic, otpType },
        data: data,
    };

    return new Promise((resolve) => {
        window.SPL_Member.getRequestAuthAttemptInfo(splConfig)
            .then((res) => {
                const info = res?.data?.data || res?.data || res;
                resolve(typeof info?.count === 'number' ? info : null);
            })
            .catch(() => resolve(null));
    });
}

export function mu_postRequestAuth(otpType, data, isPublic = false, context = 'withdrawal') {
    const splConfig = {
        otpOptions: { isPublic, otpType },
        data: data,
    };

    return new Promise((resolve, reject) => {
        window.SPL_Member.postRequestOTP(splConfig)
            .then((res) => {
                if (res || res?.data) {
                    resolve(res?.data || res);
                } else {
                    reject(handleErrorResponse(res, context));
                }
            })
            .catch((error) => {
                reject(handleErrorResponse(error, context));
            });
    });

    function handleErrorResponse(response, context) {
        return {
            errDescription: response?.response?.data?.description || response?.data?.description,
            customErrDescription: getErrorMessageKeyMap(response?.response?.data?.description || response?.data?.description),
            rawErrMsg: response?.response?.data?.message || response?.data?.message,
            customErrMsg: getErrorMessageKeyMap(response?.response?.data?.message || response?.data?.message),
            errMsg: window.SPL_Translation.getTranslatedErrorMsg(response?.response?.data || response?.data, context),
            errCode: response?.response?.data?.errorCode || response?.data?.errorCode,
        };
    }

    function getErrorMessageKeyMap(error) {
        if (!error) return '';

        let errMsg = 'global:global.verification.generalError';
        switch (error) {
            case 'Phone Registered':
                errMsg = 'register:register.messages.error.phoneexists';
                break;
            case 'Maximum Attempts Exceed':
                errMsg = 'global:global.verification.maxAttempts';
                break;
            case 'captcha triggered':
                errMsg = 'captcha triggered';
                break;
            case 'Email Incorrect':
                errMsg = 'global:global.verification.differentEmail';
                break;
            case 'transaction.transfer.email.has.been.verified':
                errMsg = 'global:global.verification.yourEmailVerified';
                break;
            default:
                break;
        }

        return errMsg;
    }
}

/**
 * This function is used for filtered menus for unsupported feature. Hence, can preset the menu.
 */
export const mu_filterMenusBasedOnFeatures = ({ dispatch, missionDiary, luckyWheel, referralProps, portalSettings, isLogin }) => {
    const portalFeatures = window.portalSettings?.features;

    return {
        rewardcentre: async () => {
            if (portalFeatures?.enableRewardCentre) {
                return true;
            }
            return false;
        },
        missiondiary: async () => {
            if (portalFeatures?.enableMissionDiary) {
                try {
                    const isMenuRequiredHide = await mu_checkToShowMissionDiaryV2(missionDiary, dispatch);
                    return isMenuRequiredHide;
                } catch (err) {
                    console.error(err);
                    return false;
                }
            }
            return false;
        },
        luckywheel: () => {
            if (portalFeatures?.enableLuckyWheel && luckyWheel?.details?.luckyWheelSettingId) {
                return true;
            }
            return false;
        },
        referral: async () => {
            if (isLogin) {
                const vm = {
                    props: {
                        referralProps: referralProps,
                        portal: portalSettings,
                        dispatch: dispatch,
                    },
                };
                try {
                    const { referralRewards, referralComm, isMultiTierReferral, enableReferralProgram } = await mu_getReferralTypeEnabledV2(vm);
                    return referralRewards || referralComm || isMultiTierReferral || enableReferralProgram;
                } catch (err) {
                    console.error(err);
                    return false;
                }
            }
            return false;
        },
        rebate: () => {
            if (portalFeatures?.isOpenInstantRebate) {
                return true;
            }
            return false;
        },
    };
};

export async function mu_getMissionCategoryList(missionCategoryList, features) {
    if ((missionCategoryList || []).length > 0) return missionCategoryList;
    const getMissionCategoryList = await window.SPL_Member.getAllTypeMissionCategory();
    missionCategoryList = features?.missionCategoryList;

    if ((getMissionCategoryList?.missionCateogry || []).length > 0) {
        missionCategoryList = [
            {
                value: '',
                desc: 'transaction:transaction.history.filter.all',
            },
        ];

        getMissionCategoryList?.missionCateogry.map((type) => {
            missionCategoryList.push({
                value: type,
                desc: 'settings:settings.missiondiary.missionType.' + type,
            });
        });
    }

    return missionCategoryList;
}

export function mu_getReferralNotificationStatus(vm) {
    const { showReferenceBonusAnnounce } = vm?.props?.portalSettingsReducer?.portalSettings?.features?.referralSettings || {};
    showReferenceBonusAnnounce &&
        window.SPL_Member.getReferralNotificationStatus({ type: 'NEW_MEMBER_REFERRAL' }).then((data) => {
            if (data) {
                const referenceBonusAmmouncement = vm?.props?.referralProps?.referenceBonusAmmouncement || {};
                vm.props.dispatch(
                    referralAction.getReferralBonusAnnouncement({
                        referenceBonusAmmouncement: { ...referenceBonusAmmouncement, referenceBonusActive: !!data?.id, referenceBonusId: data?.id },
                    })
                );
            }
        });
}

export function mu_getReferralBonusDaily(props) {
    const { showReferenceBonusAnnounce } = props?.portalSettingsReducer?.portalSettings?.features?.referralSettings || {};
    showReferenceBonusAnnounce &&
        window.SPL_Member.getReferralBonusDaily().then((data) => {
            if (data) {
                const referenceBonusAmmouncement = props?.referralProps?.referenceBonusAmmouncement || {};
                props.dispatch(
                    referralAction.getReferralBonusAnnouncement({
                        referenceBonusAmmouncement: { ...referenceBonusAmmouncement, referralBonusDaily: data },
                    })
                );
            }
        });
}

const checkMasterSwitchCache = new Map();
export async function mu_filterByMasterSwitch(items, dispatch, currencyCode) {
    if (!items || (Array.isArray(items) && items.length === 0)) {
        return items;
    }

    const itemsArray = Array.isArray(items) ? items : [items];

    const allPromises = itemsArray.map(async (item) => {
        if (!item?.masterSwitch?.moduleType || !item?.masterSwitch?.enableKey) {
            return item;
        }

        try {
            const cacheKey = item.masterSwitch.moduleType;

            if (!checkMasterSwitchCache.has(cacheKey)) {
                const splConfig = {
                    otpOptions: {
                        otpType: item.masterSwitch.moduleType,
                        isPublic: true,
                        isNew: true,
                        currencyCode,
                    },
                    authSettingsType: item.masterSwitch.moduleType,
                    isReqUpdate: false,
                    version: 'v2',
                    isPublic: true,
                };

                const promise = dispatch(fetchAuthSettings({ splConfig })).unwrap();
                checkMasterSwitchCache.set(cacheKey, promise);
            }

            const resp = await checkMasterSwitchCache.get(cacheKey);
            const isEnabled = get(resp?.processedData ?? resp?.moduleData, item.masterSwitch.enableKey);

            return isEnabled ? item : null;
        } catch (error) {
            console.error('Master switch check error:', error);
            return null;
        }
    });

    const results = await Promise.all(allPromises);
    const filteredItems = results.filter(Boolean);

    if (Array.isArray(items)) {
        return filteredItems;
    }
    return filteredItems.length > 0 ? filteredItems[0] : null;
}
